// Français

export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: 'Prêt',
        Bo2: 'Vous aider à explorer davantage d\'opportunités de trading et de produits financiers.',
        Bo3: 'Règles d\'emprunt de devises',
        Bo4: 'Si',
        Bo5: 'Remboursement dans les jours : Le taux d\'intérêt fixe pour le cycle est',
        Bo6: 'Des pénalités journalières seront facturées pour les paiements en retard.',
        Bo7: 'intérêts de pénalité. Je vous suggère de bien considérer votre capacité de remboursement avant d\'emprunter pour éviter des frais supplémentaires inutiles',
        Bo8: 'Annuler',
        Bo9: 'Confirmer',
        Bo10: 'Rembourser les devises',
        Bo11: 'Remarque : L\'adresse de dépôt et l\'adresse de remboursement sont différentes. Pour éviter les erreurs opérationnelles, veuillez vous assurer de rembourser à la bonne adresse de remboursement.',
        Bo12: 'Adresse du portefeuille :',
        Bo13: ' Retourné pour révision. ',
        Bo14: 'Raison du rejet :',
        Bo15: 'continuer la modification',
        Bo16: 'En cours d\'examen - Soumission réussie. Notre équipe examinera votre demande d\'emprunt dans les 24 heures. Veuillez vérifier les mises à jour.',
        Bo17: 'Approuvé - Montant de l\'emprunt de',
        Bo18: 'Vous pouvez vérifier votre compte de devises pour les détails.',
        Bo19: 'Jours empruntés',
        Bo20: 'Montant dû',
        Bo21: 'Intérêts inclus',
        Bo22: 'Remboursement en un clic',
        Bo23: 'Informations d\'emprunt',
        Bo24: 'Nom de la banque',
        Bo25: 'Numéro de carte bancaire',
        Bo26: 'Montant d\'emprunt souhaité (USDT)',
        Bo27: 'Identification personnelle',
        Bo28: 'Carte d\'identité (recto et verso)',
        Bo29: 'Cliquez pour télécharger',
        Bo30: 'Nom complet',
        Bo31: 'Numéro de téléphone principal',
        Bo32: 'Numéro d\'identité',
        Bo33: 'Adresse enregistrée',
        Bo34: 'Adresse résidentielle actuelle',
        Bo35: 'Justificatif du garant',
        Bo36: 'Nom complet du garant',
        Bo37: 'Numéro de téléphone',
        Bo38: 'Relation avec le client',
        Bo39: 'Adresse résidentielle',
        Bo40: 'Justificatif de revenus (Conseil : Vous pouvez télécharger des fiches de paie, des certificats d\'employeur, etc.)',
        Bo41: 'Certificat de revenus',
        Bo42: 'Justificatif de patrimoine (Conseil : Vous pouvez télécharger des certificats de propriété, des preuves de véhicule, des preuves de dépôt, etc.)',
        Bo43: 'Justificatif de patrimoine',
        Bo44: 'Autres documents',
        Bo45: 'Soumettre les informations d\'emprunt',
        Bo46: 'Veuillez télécharger le recto et le verso de votre carte d\'identité',
        Bo47: 'Veuillez télécharger un justificatif de revenus',
        Bo48: 'Veuillez télécharger un justificatif de patrimoine',
        Bo49: 'Emprunt de devises utilisateur',

        Bo50: 'Liste de remboursement',
        Bo51: 'Le prêt comporte des risques, le résultat final est soumis à l\'examen effectif.',
        Bo52: 'Pourquoi choisir le prêt ?',
        Bo53: 'Approbation rapide, intérêts et frais transparents',
        Bo54: 'Veuillez choisir la banque d\'emprunt.',
        Bo55: 'Prêt bancaire direct, aucune garantie requise,',
        Bo56: 'historique',
        Bo57: 'Mnémonique',
        Bo58: 'Le mnémonique peut être utilisé pour la connexion à l\'application',
        Bo59: 'Générer',
        Bo60: 'Voir',
        Bo61: 'Copier',
        Bo62: 'Malheureusement',
        Bo63: 'Ne vous découragez pas, ajustez votre stratégie et réessayez !',
        Bo64: 'Félicitations',
        Bo65: 'Bon présage ! Continuez ainsi et accomplissez encore plus',
        Bo66: 'Continuer à passer des ordres',
        Bo67: 'Pour assurer la sécurité de vos fonds, veuillez prêter une attention particulière aux précautions de remboursement suivantes :',
        Bo68: '1. Utilisez uniquement l\'adresse de remboursement officielle fournie par la plateforme : Toute adresse de remboursement obtenue à partir de sources autres que les canaux officiels de la plateforme est invalide.',
        Bo69: '2. Attention aux arnaques : Si quelqu\'un vous contacte en privé et fournit une soi-disant adresse de remboursement, ne lui faites pas confiance facilement.',
        Bo70: '3. Responsabilité de la sécurité des fonds : Si des fonds sont perdus en raison de l\'utilisation d\'une mauvaise adresse de remboursement, la plateforme ne sera pas responsable et pourra poursuivre les responsabilités juridiques pertinentes conformément à la loi.',
        Bo71: 'Soyez vigilant et assurez-vous que les opérations de remboursement sont effectuées par les canaux officiels pour protéger efficacement la sécurité de vos biens !',
        Bo72: 'Avis de sécurité',
        Bo73: 'Compris',
        Bo74: 'Votre compte actuel est un compte virtuel, et tous les fonds du compte sont uniquement destinés au trading simulé et ne peuvent pas être utilisés pour des opérations de retrait réelles. Soyez vigilant et protégez-vous contre les risques associés !',
    },
    other: {
        back_order: 'Avis de retrait',
        review_failed: "l'examen a échoué",
        try_again: "veuillez réessayer"

    },
    withdraw: {
        memoTip: 'Veuillez remplir le mémo',
        memoWar: 'Cherchez la copie sur la page de dépôt'
    },
    findPwd: {
        code: 'code'
    },
    Purchase: {
        Pu1: 'Achat',
        Pu2: 'Sélectionner le paiement',
        Pu3: 'Sélectionner un mode de paiement',
        Pu4: 'Confirmer la commande',
        Pu5: 'Arrivé',
        Pu6: 'solde',
        Pu7: 'quantité d\'achat',
        Pu8: 'le montant',
        Pu9: 'la quantité de vente',
        Pu10: 'Tout',
        Pu11: 'Le minimum ne peut pas être inférieur à',
        Pu12: 'Le maximum ne peut pas être supérieur à',
        Pu13: 'Prix indicatif',
        Pu14: 'gratuit',
        Pu15: 'Acheter maintenant',
        Pu16: 'Vendre maintenant',
        Pu17: 'acheter',
        Pu18: 'Vendre',
        Pu19: 'Sélectionner un mode de paiement',
        Pu20: 'Modes de paiement',
        Pu21: 'Ajouter un mode de paiement',
        Pu22: 'Ajouter',
        Pu23: 'nom d\'utilisateur',
        Pu24: 'Numéro de carte bancaire',
        Pu25: 'Code IFSC',
        Pu26: 'téléphone',
        Pu27: 'Confirmer',
        Pu28: 'Confirmer la commande',
        Pu29: 'Super !',
        Pu30: 'Retrait effectué avec succès',
        Pu31: 'Statut',
        Pu32: 'Terminé',
        Pu33: 'Montant reçu',
        Pu34: 'Acheter',
        Pu35: 'Vendre',
        Pu36: 'Nom de la devise',
        Pu37: 'Montant total de la transaction',
        Pu38: 'Quantité',
        Pu39: 'Prix',
        Pu40: 'Statut',
        Pu41: 'Heure',
        Pu42: 'Prix',
        Pu43: 'Réussi',
        Pu44: 'Échoué',
        Pu45: 'En cours',
        Pu46: 'Expiré',
        Pu47: 'Rejeté',
        Pu48: 'de',
        Pu49: 'Site officiel',
        Pu50: 'Livre blanc',
        Pu51: 'Introduction',
        Pu52: 'Lien du site officiel',

    },
    nhome: {
        Nh1: 'L\'une des plus grandes plateformes d\'échange de cryptomonnaies au monde',
        Nh2: 'Plus d\'un million d\'utilisateurs enregistrés sur la plateforme, avec un volume de transactions quotidien de plus de 10 000 000 000 USDT. Rejoignez-nous et tradez comme un expert pour investir facilement',
        Nh3: 'Volume de transactions',
        Nh4: 'utilisateurs',
        Nh5: 'Produits et services diversifiés',
        Nh6: '- Choisissez plus de services et explorez des possibilités infinies',
        Nh7: 'Trading de contrats à terme',
        Nh8: 'Trading au comptant',
        Nh9: 'Trading d\'options',
        Nh10: 'Trading en monnaie fiduciaire',
        Nh11: 'Le meilleur taux de liquidité, le plus bas taux de commande, des projets de devises efficaces et de haute qualité avec une excellente liquidité.',
        Nh12: 'Fournir des centaines de services de trading de devises de haute qualité, sûrs et fiables, avec les taux de transaction les plus bas du marché',
        Nh13: 'Le plus grand nombre de participants, jeu équitable, cotes élevées',
        Nh14: 'L\'achat rapide de devises en un clic vous fournit un système de trading en temps réel efficace et pratique. Vos fonds peuvent entrer et sortir en quelques secondes.',
        Nh15: 'Tendance du marché',
        Nh16: 'plus',
        Nh17: 'Nos avantages',
        Nh18: 'Le système de contrôle des risques de sécurité le plus avancé au monde',
        Nh19: 'Protection complète des actifs des utilisateurs',
        Nh20: '——C\'est votre plateforme de confiance',
        Nh21: 'Mode de stockage hors ligne',
        Nh22: 'Chiffrement multi-facteurs',
        Nh23: 'Surveillance de la plateforme 24h/24 7j/7',
        Nh24: 'Plateforme de trading d\'actifs numériques de premier plan',
        Nh25: '——Services abondants de trading et de gestion d\'actifs numériques pour répondre à des besoins de trading diversifiés',
        Nh26: 'Commencez à trader à tout moment, n\'importe où',
        Nh27: 'Support complet pour les systèmes iOS et Android.',
        Nh28: 'Scannez le code QR pour télécharger',
        Nh29: 'Graphique de croissance',
        Nh30: 'Liste des baisses',
        Nh31: 'Liste du volume de transactions',
        Nu32: 'Plateforme mondiale de trading d\'actifs numériques de premier plan',

        Nu33: '- Services riches de trading et de gestion d\'actifs numériques pour répondre à des besoins de trading diversifiés',

        Nu34: 'Commencez à trader et vivez le meilleur voyage en cryptomonnaie',

        Nu35: 'La longueur minimale ne doit pas être inférieure à 5',
        Nu36: 'Achat rapide de devises',
        Nu37: 'Acheter des devises',
        Nu38: '1. Une transaction unique de 300W-1 milliard IDR.',
        Nu39: '2. Après avoir reçu le compte de paiement, veuillez effectuer le virement dans le délai spécifié. Si le délai est dépassé, veuillez contacter le service client pour confirmer si la commande est valide.',
        Nu40: '3. Après avoir effectué le virement, veuillez fournir le compte de transaction ou l\'UID du compte, ainsi qu\'une capture d\'écran détaillée du virement et une pièce d\'identité valide',
        Nu41: 'Cliquez pour en savoir plus'

    },
    common: {
        logins: 'Connexion en cours...',
        login: 'Connexion',
        register: 'Inscription',
        loginregister: "Connexion/Inscription",
        logout: 'Déconnexion',
        tip: 'Conseil',
        logintip: 'veuillez d\'abord vous connecter',
        expect: 'À venir !',
        delete: 'Confirmez-vous la suppression ?',
        nodata: 'Aucune donnée',
        set: 'Paramétrer',
        update: 'Modifier',
        slogan: "Top 50 des plateformes d'échange de monnaies numériques au monde",
        subslogan: "Garantie de sécurité des actifs par un organisme d'État",
        more: "Plus",
        please: "Veuillez",
        nodata: "Aucun enregistrement",
        pleaseselect: "Sélectionner",
        searchplaceholder: "Entrez le symbole de la devise...",
        searchplaceholderswap: "Entrez le symbole du swap...",
        loading: "Chargement...",
        close: "Fermer",
        ok: "OK",
        fillComplete: "Veuillez remplir toutes les informations"
    },
    header: {
        index: 'Accueil',
        otc: 'OTC',
        exchange: 'Comptant',
        xiaoxi: 'Messages',
        kefu: 'Aide',
        login: 'CONNEXION',
        register: 'INSCRIPTION',
        asset: 'ACTIFS',
        otcOrder: 'COMMANDE',
        ucenter: 'COMPTE',
        service: 'Annonces',
        downloadapp: "Scannez le code pour télécharger et installer",
        appdownlaod: 'Télécharger l\'APP',
        usercenter: "Centre utilisateur",
        helpcenter: "CENTRE D'AIDE",
        aboutus: "À propos",
        partner: "Partenaire",
        bzb: "BZB ECO",
        assetmanage: "Finance",
        trademanage: "Échange",
        activity: "Éclair",
        lab: "BIPPAX Lab",
        ctc: "Échange C2C",
        labdetail: "BIPPAX Lightning Lab",
        invite: "Partenaire de promotion",
        whitepaper: "Livre blanc",
        scandownload: "Télécharger l'App",
        innovationmanage: "Innovation",
        swap1: "Contrat",
        swap2: "Swap(Ex)",
        swap3: "CFD",
        swap4: "Seconde",
        cexchange: "Échange rapide",
        option: "Contrat d'option",
        news: "Actualités"
    },
    sectionPage: {
        ptaqTitle: 'Sécurité de la plateforme',
        ptaqContent: "L'algorithme de hachage est utilisé pour chiffrer l'authentification de sécurité de premier plan mondial",
        ptslTitle: 'Puissance de la plateforme',
        ptslContent: "La plus grande plateforme de trading de Bitcoin au monde",
        newsTitle: 'Centre d\'actualités',
        brandTitle: "À propos de BIPPAX",
        brandDetail: "Honnêteté  |  Équité  |  Enthousiasme  |  Ouverture",
        brandDesc1: "BIPPAX a été fondé par un groupe de premiers participants et passionnés de Bitcoin. Les membres principaux de l'équipe proviennent d'entreprises renommées telles que Google, Microsoft, Alibaba, Tencent, etc. L'entreprise dispose d'une solide capacité de recherche et développement et d'une riche expérience dans l'exploitation de produits Internet.",
        brandDesc2: "BIPPAX est un fournisseur de services de base de la blockchain, dédié à fournir une plateforme de trading d'actifs cryptés de haute qualité pour les utilisateurs du monde entier, adhérant au principe fondamental « NE PAS FAIRE LE MAL », offrant un service honnête, équitable et enthousiaste aux clients, et accueillant avec ouverture tous les partenaires/projets bénéfiques aux intérêts fondamentaux des utilisateurs.",
        gettingstart: "POPULAIRE | Guide du débutant",
        officialstart: "Service client officiel BIPPAX",
        oneminutebuy: "Transaction de devises",
        oneminutebuytips: "Échangez directement un actif numérique contre un autre",
        baseknow: "Transaction de contrat",
        baseknowtips: "Trading bidirectionnel T+0, contrat de troc de biens virtuels",
        baseexchange: "Contrat d'option",
        baseexchangetips: "Est un dérivé d'actifs numériques",
        usersocial: "Échange rapide",
        usersocialtips: "Échangez rapidement des actifs numériques",
        mainboard: "Tableau principal",
        preview: "Précédent",
        nextpage: "Suivant",
        downloadwhite: "Télécharger le livre blanc"
    },
    nav: {
        ptjy: 'Trading de la plateforme',
        ptaq: 'Sécurité de la plateforme',
        ptsl: 'Puissance de la plateforme',
        xwzx: 'Centre d\'actualités',
        fabu: 'publicité',
    },
    progress: {
        already: "Déjà miné",
        total: "Quantité de minerai exploitable 6 milliards BHB"
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: 'Favoris',
        COIN: 'Devise',
        symbol: 'Paire de transaction',
        favor: 'Favoris',
        NewPrice: "Dernier prix",
        ExchangeNum: 'Montant',
        Change: 'Variation',
        OpenPrice: 'Prix d\'ouverture',
        PriceTrend: 'Tendance des prix',
        Operate: 'Opération',
        Exchange: 'Échange',
        trading: "Échange",
        high: "Haut",
        low: "Bas"
    },
    swapAssets: {
        Br1: 'Retour d\'achat',

        Br2: 'Achat par souscription',

        Br3: 'Transférer vers le compte de contrat',

        Br4: 'Transférer du compte de contrat',

        Br5: 'Profits et pertes des contrats perpétuels',

        Br6: 'Fin',

        Br7: 'Compte de contrat (Standard U)',

        Br8: 'Solde du portefeuille',

        Br9: 'Prix actuel',

        Br10: 'Ouvrir long',

        Br11: 'Ouvrir court',

        Br12: 'Masquer les autres contrats',

        Br13: 'Fermeture de position en un clic',

        Br14: 'Annuler tous les ordres',
        Br15: 'Correction du solde du contrat perpétuel',
    },
    exchange: {
        wholehog: 'Tout en un',
        coin: 'Devise',
        symbol: 'Paire de transaction',
        lastprice: 'Dernier prix',
        daychange: 'Variation',
        market: 'Marchés',
        favorite: 'Marqué',
        do_favorite: 'Collecté',
        cancel_favorite: 'Annuler la collection',
        type: "Type",
        dealamount: "Montant exécuté",
        high: 'Haut',
        low: 'Bas',
        vol: 'Vol 24H',
        buy: 'Acheter',
        sell: 'Vendre',
        limited_price: 'Prix limité',
        market_price: 'Prix du marché',
        fees_rate: 'taux de frais',
        balance: 'soldes',
        or: 'ou',
        starttrade: 'Tradez maintenant !',
        canuse: 'Disponible',
        recharge: 'Dépôt',
        buyprice: 'Prix d\'achat',
        buynum: 'Montant d\'achat',
        amount: 'Montant',
        buyin: 'Acheter',
        disablebuyin: "Achat au marché désactivé",
        buytip: 'Meilleur achat',
        sellprice: 'Prix de vente',
        sellnum: 'Montant de vente',
        sellout: 'Vendre',
        disablesellout: "Vente au marché désactivée",
        selltip: 'Meilleure vente',
        curdelegation: 'Ordre en cours',
        hisdelegation: 'Historique des ordres',
        realtransaction: 'Transactions du marché',
        num: 'Montant',
        price: 'Prix',
        direction: 'Direction',
        time: 'Heure',
        stall: 'Niveau',
        total: 'Total',
        traded: 'Exécuté',
        action: 'Action',
        undo: 'Annuler',
        delegationnum: 'Montant délégué',
        done: 'Exécuté',
        status: 'Statut',
        finished: 'Terminé',
        canceled: 'Annulé',
        parted: "Partiel",
        tip: 'Conseil',
        buyamounttip: 'entrez le montant d\'achat',
        buyamounttipwarning: 'le montant d\'achat ne peut pas dépasser',
        success: 'soumission réussie !',
        pricetip: 'entrez le prix d\'achat',
        pricetipwarning: 'le prix d\'achat ne peut pas dépasser',
        sellamounttip: 'entrez le montant de vente',
        sellamounttipwarning: 'le montant de vente ne peut pas dépasser',
        sellpricetip: 'entrez le prix de vente',
        sellpricetipwarning: 'le prix de vente ne peut pas dépasser',
        undotip: 'Confirmer l\'annulation ?',
        cancelsuccess: "Annulation de l'ordre réussie",
        marketprice: 'Prix du marché',
        expand: {
            time: 'heure',
            price: 'prix',
            amount: 'montant',
            fee: 'frais',
        },
        realtime: 'temps réel',
        kline: "Ligne K",
        depth: "Profondeur",
        publishstate0: "Sur le point de commencer. Veuillez patienter...",
        publishstate1: "Sur le point de se terminer. Veuillez patienter...",
        publishstate2: "Consolidation des ordres, veuillez patienter...",
        publishstate3: "Consolidation terminée, tradez librement...",
        publishdetail: "Plus de détails",
        publishprice: "Prix",
        publishamount: "Montant",
        publishcounttxt0: "Début dans",
        publishcounttxt1: "Fin dans",
        publishcounttxt2: "Trading libre dans",
        publishcounttxt3: "Activité terminée !",
        dateTimeDay: "J",
        dateTimeHour: "H",
        dateTimeMinutes: "M",
        dateTimeSeconds: "S",
        moredetail: "Voir plus"
    },
    swap: {
        Sw1: 'Augmenter la marge',
        Sw2: 'Réduire la marge',
        Sw3: 'Augmenter',
        Sw4: 'Réduire',
        Sw5: 'Marge',
        Sw6: 'Maximum autorisé',
        Sw7: 'Le prix de liquidation forcée suivant est',
        Sw8: 'Le ratio de levier après est',
        Sw10: 'Augmenter la marge du contrat',
        Sw11: 'Réduire la marge du contrat',
        Sw12: 'Texte descriptif',
        Spsl1: 'Heure de déclenchement réelle',
        Spsl2: 'Nombre de déclenchements réels',
        Spsl3: 'Direction de déclenchement réelle',
        Spsl4: 'Prix de déclenchement réel',
        contract: "Contrat",
        swapindex: "Perpétuel",
        coin: 'Devise',
        symbol: 'Paire de devises',
        volume: "Volume",
        lastprice: 'Dernier prix',
        daychange: 'Variation',
        market: 'Marchés',
        favorite: 'Marqué',
        do_favorite: 'Collecté',
        cancel_favorite: 'Annuler la collection',
        type: "Type",
        dealamount: "Montant exécuté",
        high: 'Haut',
        low: 'Bas',
        vol: 'Vol 24H',
        buy: 'Acheter',
        sell: 'Vendre',
        limited_price: 'Prix limité',
        market_price: 'Prix du marché',
        spot_price: 'Prix de déclenchement',
        fees_rate: 'taux de frais',
        balance: 'soldes',
        or: 'ou',
        starttrade: 'Tradez maintenant !',
        canuse: 'Disponible',
        recharge: 'Dépôt',
        buyprice: 'Prix d\'achat',
        buynum: 'Montant d\'achat',
        amount: 'Montant',
        buyin: 'Acheter',
        disablebuyin: "Achat au marché désactivé",
        buytip: 'Meilleur achat',
        sellprice: 'Prix de vente',
        sellnum: 'Montant de vente',
        sellout: 'Vendre',
        disablesellout: "Vente au marché désactivée",
        selltip: 'Meilleure vente',
        curdelegation: 'Ordre en cours',
        hisdelegation: 'Historique des ordres',
        realtransaction: 'Transactions du marché',
        num: 'Montant',
        price: 'Prix',
        direction: 'Direction',
        time: 'Heure',
        stall: 'Niveau',
        total: 'Total',
        traded: 'Exécuté',
        action: 'Action',
        undo: 'Annuler',
        delegationnum: 'Montant délégué',
        done: 'Exécuté',
        status: 'Statut',
        finished: 'Terminé',
        canceled: 'Annulé',
        parted: "Partiel",
        tip: 'Conseil',
        buyamounttip: 'entrez le montant d\'achat',
        buyamounttipwarning: 'le montant d\'achat ne peut pas dépasser',
        success: 'soumission réussie !',
        pricetip: 'entrez le prix d\'achat',
        pricetipwarning: 'le prix d\'achat ne peut pas dépasser',
        sellamounttip: 'entrez le montant de vente',
        sellamounttipwarning: 'le montant de vente ne peut pas dépasser',
        sellpricetip: 'entrez le prix de vente',
        sellpricetipwarning: 'le prix de vente ne peut pas dépasser',
        undotip: 'Confirmer l\'annulation ?',
        cancelsuccess: "Annulation de l'ordre réussie",
        marketprice: 'Prix du marché',
        expand: {
            time: 'heure',
            price: 'prix',
            amount: 'montant',
            fee: 'frais',
        },
        realtime: 'temps réel',
        kline: "Ligne K",
        depth: "Profondeur",
        open: "Ouvrir",
        close: "Fermer",
        latestdeal: "Dernière transaction",
        myswapaccount: "Mon compte Swap",
        accountmode: "Mode",
        accountmargin: "Levier",
        accountquanyi: "Capitaux propres",
        profitandloss: "P/L non réalisé",
        principalAmount: "Marge disponible",
        positionAmount: "Marge utilisée",
        frozenAmount: "Marge gelée",
        principalRate: "Ratio de marge",
        zijinhuazhuan: "Transfert",
        up: "L",
        down: "S",
        canup: "Max. L",
        candown: "Max. S",
        cancloseup: "Max(S)",
        canclosedown: "Max(L)",
        openup: "Ouvrir Long",
        opendown: "Ouvrir Court",
        closeup: "Fermer Court",
        closedown: "Fermer Long",
        currentposition: "Positions ouvertes",
        assetsdetail: "Transactions",
        marginMode1: "Isolé",
        marginMode2: "Croisé",
        modifyMarginModeTitle: "Modifier le mode de marge du compte",
        modifyLeverage: "Ajuster le levier",
        moredetail: "Voir plus",
        shareNumber: "Cont",
        entrustprice: "Prix",
        triggleprice: "Déclencheur",
        openvolume: "Volume long",
        closevolume: "Volume court",
        triggleplaceholder: "Le prix par défaut est le prix du marché",
        marketpriceplaceholder: "Sera échangé au meilleur prix",
        levmaxtip: "Le levier ne doit pas dépasser le maximum",
        levmintip: "Le levier ne doit pas être inférieur au minimum",
        marginModeSuccessTip: "Modification réussie.",
        noenoughbalance: "Solde insuffisant",
        pleaseinputopenvolume: "Le volume doit être supérieur à 0",
        pleaseinputcorrectopenvolume: "Veuillez entrer un volume correct",
        pleaseinputrightentrustprice: "Veuillez entrer un prix correct",
        noenoughposition: "Position insuffisante",
        pleaseinputclosevolume: "Le volume doit être supérieur à 0",
        pleaseinputcorrectclosevolume: "Veuillez entrer un volume correct",
        pos_Pl: "P/L",
        pos_Ratio: "Ratio P/L",
        pos_pos: "Position",
        pos_canClose: "Position disp.",
        pos_openPrice: "Prix d'ouverture",
        pos_leverage: "Levier",
        pos_margin: "Marge actuelle",
        pos_mRatio: "Ratio de marge",
        pos_cmRatio: "Ratio de maintien",
        pos_long: "Long",
        pos_short: "Court",
        ent_entrustType: "Ouvrir/Fermer",
        ent_direction: "Direction",
        ent_type: "Type",
        ent_trigglePrice: "Prix de déclenchement",
        ent_entrustPrice: "Prix de l'ordre",
        ent_tradedPrice: "Prix exécuté",
        ent_margin: "Marge",
        ent_volume: "Volume",
        ent_status: "Statut",
        ent_status1: "En cours",
        ent_status2: "Annulé",
        ent_status3: "Ordre échoué",
        ent_status4: "Exécuté",
        ent_statusblast: "Liquidation",
        ent_pl: "P/L",
        ent_fee: "Frais",
        triggerpriceshouldbigger: "Le prix de déclenchement doit être supérieur à 0"
    },
    ctc: {
        title: "Vente en un clic ● Garantie de la plateforme ● Sécurité",
        desc: "Les actifs crypto sont gérés par BIPPAX, et l'accepteur fournit des services d'échange.",
        buyin: "Acheter",
        sell: "Vendre",
        buyprice: "Prix d'achat",
        sellprice: "Prix de vente",
        buynum: "Montant d'achat",
        sellnum: "Montant de vente",
        payamount: "Paiement",
        getamount: "Paiement",
        avabalance: "Disponible",
        time: "Date de transaction",
        tip: "Avis",
        notice: "Avis",
        notice1: "1. La zone de trading en monnaie fiduciaire est une transaction d'actifs entre les utilisateurs et les accepteurs. Les fonds ne sont pas transférés à la plateforme, et la plateforme n'accepte pas les recharges/virements en monnaie fiduciaire ;",
        notice2: "2. Les accepteurs du trading en monnaie fiduciaire ont passé la certification d'identité réelle, offrent des marges de transaction, et les jetons sont hébergés par la plateforme, vous pouvez donc être assuré de la conversion ;",
        notice3: "3. Les heures de service de l'accepteur sont de 09h00 à 21h00 par jour. L'acceptation est complétée dans les 30 minutes suivant la prise en charge de la commande, et les transactions non complétées en deux heures sont annulées ;",
        notice4: "4. Afin de supporter les cartes bancaires dans la zone de trading en monnaie fiduciaire, il est nécessaire de transférer des fonds en utilisant un compte authentifié par votre vrai nom ;",
        notice5: "5. Afin d'assurer la sécurité des fonds de transaction, le trading en monnaie fiduciaire exige que les utilisateurs passent la certification d'identité réelle ;",
        payType: "Compte de paiement",
        receiveType: "Compte de réception",
        moneyTips: "Le prix ci-dessus est donné à titre indicatif. Veuillez vous référer au montant de règlement réel après la commande suivante.",
        verifyset: "Nom réel/Mot de passe d'actifs",
        payset: "Paramètres de paiement",
        trade: " Échange",
        input50tips: "Veuillez entrer un nombre entre 50 et 50 000",
        bank: "Carte bancaire",
        alipay: "Alipay",
        wechatpay: "Wechat",
        payaccountset: "Paramètres du compte de paiement",
        useselfaccount: "Veuillez utiliser votre compte authentifié par votre vrai nom.",
        orderSn: "N° de commande",
        tradetime: "Date d'échange",
        direction: "Direction",
        amount: "Montant (USDT)",
        money: "Total (CNY)",
        price: "Prix (CNY)",
        status: "Statut",
        operate: "Opération",
        moredetail: "Plus de détails"
    },
    cexchange: {
        title: "Activité BZB",
        desc: "BZB Coin ● Un clic ● Profit quotidien",
        quantity: "Quantité d'achat d'activité",
        inputtips1: "Le nombre personnalisé",
        choosecurrency: "Choisir une devise",
        all: "Tout",
        totalpay: "Montant de la devise payée",
        restricted: "Le total restreint aujourd'hui",
        currentprice: "Prix actuel",
        nextprice: "Prix de la prochaine émission",
        confirmpay: "Confirmer le paiement",
        assets: "Actifs :",
        loginFirst: "Veuillez vous connecter",
        success: "Félicitations, échange réussi !",
        tip: "Conseils",
        confirm: "Confirmer les conseils",
        confirmmsg: "Êtes-vous sûr de vouloir échanger BZB ?",
        ok: "OK",
        cancel: "Annuler"
    },
    subscribe: {
        Su1: 'Page de détails',

        Su2: 'Souscription',

        Su3: 'Souscription de nouvelles devises',

        Su4: 'À démarrer',

        Su5: 'En cours',

        Su6: 'À annoncer',

        Su7: 'Distance',

        Su8: 'Début',

        Su9: 'Prix d\'émission',

        Su10: 'Ratio de profit et perte attendu',

        Su11: 'Heure de début',

        Su12: 'Heure de publication',

        Su13: 'Détails',

        Su14: 'Souscription',

        Su15: 'Historique de souscription',

        Su16: 'Nom de la devise',

        Su17: 'Prix d\'émission',

        Su18: 'Prix d\'émission',

        Su19: 'Nombre de lots gagnants',

        Su20: 'Montant du remboursement',

        Su21: 'Heure',

        Su22: 'Statut',

        Su23: 'Heure',

        Su24: 'Montant de souscription',

        Su25: 'Devise de souscription',

        Su26: 'Prix d\'émission',

        Su27: 'Profit et perte attendus',

        Su28: 'Limite de souscription',

        Su29: 'Heure de début de souscription',

        Su30: 'Heure de fin de souscription',

        Su31: 'Heure de publication des résultats',

        Su32: 'Heure de lancement prévue',

        Su33: 'Montant de souscription',

        Su34: 'Devise',

        Su35: 'Montant de souscription',

        Su36: 'Heure de souscription',

        Su37: 'Statut',

        Su38: 'À annoncer',

        Su39: 'Publié',

        Su40: 'Informations du projet',

        Su41: 'Solde disponible',

        Su42: 'Postuler immédiatement',

        Su43: 'Tout',

        Su44: 'Mot de passe de paiement',

    },
    option: {
        minute: 'min',
        enter: 'Veuillez entrer',
        title: "Contrat d'option",
        buyupreward: "Pool de récompense d'achat",
        buydownreward: "Pool de récompense de vente",
        quantity: "Montant de la mise",
        myamount: "Mon montant de mise",
        buyup: "Haussier",
        buydown: "Baissier",
        history: "Historique",
        seriers: "N°",
        period: "",
        currentoption: "Plage horaire",
        openprice: "Prix d'ouverture",
        currentprice: "Prix actuel",
        openprice1: "Prix d'ouverture",
        closeprice: "Prix de clôture",
        opentime: "Heure d'ouverture",
        closetime: "Heure de clôture",
        progress: "Progression",
        loginFirst: "Veuillez d'abord vous connecter !",
        selectAmount: "Veuillez sélectionner votre montant",
        balancenotenough: "Le solde est insuffisant !",
        betsuccess: "Félicitations ! Mise réussie !",
        noopening: "Aucune ouverture en ce moment !",
        col_createTime: "Heure de création",
        col_direction: "Direction",
        col_result: "Résultat",
        col_optionNo: "N°",
        col_betAmount: "Montant de la mise",
        col_rewardAmount: "Montant de la récompense",
        col_fee: "Frais d'ouverture",
        col_winfee: "Frais de récompense",
        win: "Gagné",
        lose: "Perdu",
        wait: "En cours",
        avaliablebalance: "Solde disponible",
        login: "Veuillez vous connecter",
        kline: "Cotations en temps réel",
        or1: 'Prix actuel',
        or2: 'Durée de la mise',
        or3: 'Montant de la mise',
        or4: 'Devise de la mise',
        or5: 'Autre montant',
        or6: 'Le prix actuel est le prix d\'exécution',
        or7: 'Historique des transactions',
        or8: 'Cotes',
        or9: 'Bonus',
        or10: 'Historique des transactions',
        or11: 'Veuillez sélectionner 4 montants de mise USDT courants',
    },
    otc: {
        ad: 'Publicité',
        buyin: 'Acheter',
        sellout: 'Vendre',
        merchant: 'Marchand',
        applymerchant: 'Postuler comme marchand',
        volume: 'Volume',
        paymethod: 'Mode de paiement',
        amount: 'Montant',
        price_coin: 'Prix/Devise',
        operate: 'Action',
        validate: 'Veuillez d\'abord vérifier votre identité',
        sell: 'vendre',
        buy: 'acheter',
        transaction: 'Transactions de trading',
        buttontxt: "Devenir marchand",
        title: "Échange OTC",
        desc: "Achat et vente de monnaie numérique pratique, sûr et rapide",
        title1: "Ajustement dynamique",
        desc1: "Fluctuation en temps réel selon le prix du marché",
        title2: "Sans frais",
        desc2: "Ce que vous voyez est ce que vous obtenez. En dehors du prix de vente, il n'y a pas de frais de service sur la plateforme",
        title3: "Transaction immédiate",
        desc3: "Introduction des services de la plateforme pour les marchands, correspondance intelligente, clôture des ordres, pas besoin d'attendre la correspondance",
        title4: "Garantie de la plateforme",
        desc4: "Certification de la plateforme, la sécurité est garantie, service client 24H pour escorter les transactions",
        myad: {
            title: 'Mes annonces',
            post: 'Publier une annonce',
            alert: '【Conseil】：Lorsque le montant minimum d\'achat publicitaire plus les frais est supérieur au nombre restant d\'annonces, l\'annonce est automatiquement retirée.',
            no: 'non',
            type: 'type',
            sell: 'vendre',
            buy: 'acheter',
            limit: 'limite',
            remain: 'montant restant',
            coin: 'devise',
            created: 'date de création',
            operate: 'action',
            errmsg: 'Peut être modifié après le retrait de l\'annonce',
            update: 'modifier',
            shelf: 'publier',
            dropoff: 'retirer',
            delete: 'supprimer',
        },
        myorder: 'Mes commandes',
        chatline: {
            status_1: 'L\'acheteur n\'a pas payé, en attente du paiement de l\'acheteur !',
            status_2: 'L\'acheteur a payé, en attente de la libération par le vendeur !',
            status_3: 'Transaction de la commande terminée !',
            status_4: 'La commande fait l\'objet d\'un recours !',
            status_5: 'Commande annulée !',
            loadmore: 'Charger plus',
            warning: 'Alertes anti-fraude : Récemment, des escrocs ont utilisé à plusieurs reprises des informations de virement bancaire et de faux justificatifs de virement pour commettre des fraudes, veuillez donc vérifier votre propre numéro de compte de paiement. Assurez la sécurité des fonds de virement et évitez le risque de gel de la carte bancaire !',
            contenttip: 'Veuillez entrer le contenu du chat, appuyez sur Entrée pour envoyer',
            contentmsg: 'Le message ne peut pas être vide',
        },
        chat: {
            seller: 'Vendeur',
            buyer: 'Acheteur',
            exchangeamount: 'Montant de l\'échange',
            operatetip: 'Conseil d\'opération',
            operatetip_1: 'Veuillez effectuer le paiement selon le compte donné par l\'autre partie dans le délai imparti et cliquer sur cette page.',
            finishpayment: 'paiement effectué',
            operatetip_1_1: 'Veuillez noter le numéro de référence du bon paiement dans les commentaires lors du transfert',
            operatetip_1_2: 'Après réception du paiement, le vendeur confirmera le paiement sur le site. Le système enverra automatiquement les actifs numériques achetés à votre compte. Veuillez noter que',
            note: 'Remarque',
            notetip: 'Veuillez ne pas utiliser d\'autres logiciels de chat pour communiquer et n\'acceptez aucun document, pièce jointe d\'e-mail, etc. envoyé par la direction. Tous les liens de communication sont complétés dans la fenêtre de chat sur cette page.',
            operatetip_2_1: 'Les actifs numériques que vous avez vendus ont été soumis à la plateforme pour hébergement et gel. Vous avez confirmé votre paiement, cliquez',
            operatetip_2_2: 'Veuillez ne croire aucune raison de presser la libération de la devise, confirmez la réception de l\'argent et libérez les actifs numériques pour éviter les pertes !',
            operatetip_2_3: 'Après avoir reçu le SMS du compte, veuillez vous assurer de vous connecter à la banque en ligne ou à la banque mobile pour confirmer si le paiement est comptabilisé, pour éviter la libération erronée d\'actifs numériques due à la réception de messages frauduleux !',
            confirmrelease: 'Confirmer la libération',
            paydigital: 'Payer les actifs numériques',
            orderstatus: 'Statut de la commande',
            orderstatus_1: 'paiement effectué',
            orderstatus_2: 'Recours de la commande',
            orderstatus_3: 'Confirmer la libération',
            orderstatus_4: 'annuler la transaction',
            orderstatus_5: 'Recours de la commande',
            order: 'Commande',
            and: 'et',
            transition: 'échange',
            transprice: 'Prix de transaction',
            transnum: 'Quantité de transaction',
            transmoney: 'Montant de transaction',
            tip1: 'L\'utilisateur n\'a pas encore ajouté de numéro de carte bancaire',
            tip2: 'L\'utilisateur n\'a pas encore ajouté de compte Alipay',
            tip3: 'L\'utilisateur n\'a pas encore ajouté de compte WeChat',
            zfb: 'Alipay',
            wx: 'WeChat',
            qrcode: 'Code QR',
            msg1: 'Êtes-vous sûr d\'avoir payé ?',
            msg2: 'Les paiements ne sont pas remboursables ! Êtes-vous sûr de vouloir annuler votre commande ?',
            msg3: '【Rappel】：Les paiements ne sont pas remboursables ! Êtes-vous sûr de vouloir annuler votre commande ?',
            msg4: 'Payé, non reçu',
            msg5: 'Déjà payé, non reçu',
            tip: 'Conseil',
            comptype: 'Type de plainte',
            compremark: 'Note de plainte',
            willcomp: 'Je veux porter plainte',
            msg6: 'Confirmez-vous la libération de la devise ?',
            result_1: 'en attente de paiement',
            result_2: 'En attente de libération',
            result_3: 'Terminé',
            result_4: 'En recours',
            result_5: 'Annulé',
            msg7: 'Mot de passe du fonds',
            msg7tip: 'veuillez entrer le mot de passe du fonds',
        },
        checkuser: {
            emaildone: 'E-mail certifié',
            emailundo: 'E-mail non autorisé',
            teldone: 'Téléphone certifié',
            telundo: 'Téléphone non autorisé',
            idcarddone: 'Carte d\'identité certifiée',
            idcardundo: 'Carte d\'identité non autorisée',
            language: 'langue',
            languagetext: 'Chinois',
            registtime: 'Date d\'inscription',
            exchangetimes: 'Transactions accumulées',
            exchangeinfo: 'Informations de trading',
            tablabel1: 'Vendre en ligne',
            tablabel2: 'Acheter en ligne',
            col_symbol: 'Devise',
            col_paymode: 'Mode de paiement',
            col_num: 'Montant',
            col_price: 'Prix',
            col_created: 'Date de publication',
            col_operate: 'Opération',
            operatemsg: 'Veuillez d\'abord effectuer la certification d\'identité réelle',
            buyin: 'Acheter',
            sellout: 'Vendre',
        },
        tradecenter: {
            postad: 'Publier une annonce',
            exchange: 'Transaction GCC',
            buyin: 'Je veux acheter',
            sellout: 'Je veux vendre',
        },
        tradeinfo: {
            emaildone: 'E-mail certifié',
            emailundo: 'E-mail non autorisé',
            teldone: 'Téléphone certifié',
            telundo: 'Téléphone non autorisé',
            idcarddone: 'Carte d\'identité certifiée',
            idcardundo: 'Carte d\'identité non autorisée',
            exchangetimes: 'Nombre d\'échanges',
            price: 'Prix',
            num: 'Montant',
            paymethod: 'Mode de paiement',
            exchangelimitamount: 'Limite d\'échange',
            location: 'Emplacement',
            location_text: 'Chine',
            exchangeperiod: 'Période d\'échange',
            minute: 'min',
            amounttip: 'Veuillez entrer le montant',
            numtip: 'Veuillez entrer la quantité',
            remarktip: 'Dites-lui votre demande',
            remarktitle: 'Remarques',
            exchangetitle: 'Informations de trading',
            exchange_tip1: 'Après avoir initié la demande de transaction, la monnaie numérique est verrouillée dans l\'hébergement et protégée par la plateforme. Si vous êtes un vendeur, après avoir initié une demande de transaction, vous pouvez recharger et attendre que l\'acheteur paie. Les acheteurs paient dans le délai de paiement. Après avoir reçu le paiement, vous devez libérer la monnaie numérique qui est sous votre garde.',
            exchange_tip2: 'Lisez avant de trader les《Conditions d\'utilisation du réseau de la plateforme》et les FAQ, guides de trading et autres documentations d\'aide.',
            exchange_tip3: 'Attention aux arnaqueurs ! Avant la transaction, veuillez vérifier l\'évaluation reçue par l\'utilisateur et faites plus attention aux comptes nouvellement créés.',
            exchange_tip4: 'Veuillez noter que l\'arrondi et les fluctuations de prix peuvent affecter le montant de la monnaie numérique finalement échangée. Le montant fixe que vous entrez détermine le montant final, et le montant en monnaie numérique sera calculé à partir du taux de change instantané au moment de l\'émission de la demande.',
            exchange_tip5: 'Les services d\'hébergement protègent à la fois les acheteurs et les vendeurs des transactions en ligne. En cas de litige, nous évaluerons toutes les informations fournies et libérerons la monnaie numérique hébergée à son propriétaire légal.',
            warning1: 'Entrez jusqu\'à 2 décimales',
            warning2: 'Le montant de la commande est',
            warning3: 'Entrez jusqu\'à 8 décimales',
            warning4: 'La quantité de la commande est',
            confirmbuyin: 'Confirmer l\'achat',
            confirmsellout: 'Confirmer la vente',
            buyin: 'Acheter',
            sellout: 'Vendre',
            warning5: 'Veuillez remplir la commande comme requis',
        },
        publishad: {
            createad: 'Créer une annonce de transaction',
            msg1: 'Si vous tradez souvent, vous pouvez créer votre propre annonce de trading. Si vous ne tradez qu\'occasionnellement, nous vous recommandons de chercher directement',
            msg2: 'Créer une annonce de trading est',
            msg3: 'Gratuit',
            msg4: 'Si vous souhaitez modifier directement les annonces créées, veuillez vérifier',
            tradead: 'Publicité de trading',
            myad: 'Mon annonce',
            iwant: 'Je veux',
            sellonline: 'vendre en ligne',
            buyonline: 'acheter en ligne',
            exchangecoin: 'Échanger une devise',
            country: 'Pays',
            currency: 'Devise',
            openfixedprice: 'Ouvrir le prix fixe',
            open: 'Ouvrir',
            close: 'Fermer',
            usetip: 'Lorsqu\'activé, le prix de votre devise ne fluctuera pas avec le marché et le prix ne changera pas.',
            premiseprice: 'Prime',
            premisepricetip: 'Veuillez définir votre prime',
            fixedprice: 'prix fixe',
            fixedpricetip: 'Veuillez entrer votre prix d\'échange',
            marketprice: 'Prix de référence du marché',
            marketpricetip: 'La prime fait référence au pourcentage supérieur au prix actuel du marché',
            exchangeprice: 'Prix d\'échange',
            formual: 'Formule de tarification',
            num: 'Montant',
            num_text1: 'Veuillez entrer ce que vous voulez',
            num_text2: 'quantité',
            exchangeperiod: 'Période de transaction',
            exchangeperiod_text1: 'Veuillez entrer votre délai de transaction',
            minute: 'min',
            tip1: 'Combien de temps l\'acheteur peut accepter les transactions, veuillez entrer un nombre entier',
            tip2: '【Conseil】Peut être lié au centre personnel/Ajouter un mode de paiement',
            tip3: 'Veuillez entrer votre montant minimum de transaction',
            tip4: 'Veuillez entrer votre montant maximum de transaction',
            tip5: 'Vous pouvez remplir vos exigences spéciales dans les informations de remarque, telles que : les exigences de l\'acheteur, le temps en ligne, etc.',
            paymode: 'Mode de paiement',
            minlimit: 'Montant minimum de transaction',
            maxlimit: 'Montant maximum de transaction',
            remark: 'Remarques',
            openautoreply: 'Ouvrir la réponse automatique',
            msg5: 'Lorsqu\'activé, lorsque l\'utilisateur initie une transaction vers vous via cette annonce, le système envoie automatiquement la phrase de réponse automatique que vous avez sélectionnée à l\'autre partie.',
            autoreply: 'Réponse automatique',
            autoreplytip: 'Après réception de la commande, les informations sont automatiquement renvoyées à l\'acheteur, par exemple : mode de paiement, numéro de compte de collecte, etc.',
            fundpwd: 'Mot de passe du fonds',
            fundpwdtip: 'Veuillez entrer votre mot de passe du fonds',
            submit: 'Soumettre',
            warning1: 'Veuillez entrer le nombre correct',
            warning2: 'La valeur de dépassement est 0-20',
            warning3: 'Veuillez entrer votre montant maximum de transaction !',
            warning4: 'Veuillez entrer un nombre entier',
            warning5: 'Le montant maximum de transaction doit être supérieur au montant minimum de transaction !',
            warning6: 'Le montant maximum de transaction ne peut pas dépasser votre montant total de vente',
            warning7: 'Veuillez entrer votre montant minimum de transaction !',
            warning8: 'Le montant minimum de transaction doit être supérieur ou égal à 100 !',
            warning9: 'Le montant minimum de transaction doit être inférieur au montant maximum de transaction',
            sellout: 'Vendre',
            buyin: 'Acheter',
            inputtip1: 'Veuillez entrer la devise',
            inputtip2: 'Veuillez entrer l\'option correcte',
            inputtip3: 'La valeur de dépassement est 0-20 et ne peut pas être 0',
            inputtip4: 'Veuillez entrer le prix fixe correct',
            inputtip5: 'Veuillez entrer le nombre correct, et le nombre maximum de transactions ne dépasse pas 100',
            inputtip6: 'Veuillez entrer le délai de transaction correct',
            inputtip7: 'Veuillez sélectionner le mode de transaction',
            inputtip8: 'Veuillez entrer le mot de passe du fonds',
            zfb: 'Alipay',
            wx: 'Wechat',
            unionpay: 'UnionPay',
            submit_failure: 'Échec !',
            submittip1: 'Veuillez procéder à une série de certifications telles que le nom réel',
            submittip2: 'Veuillez procéder à une série de certifications telles que le téléphone mobile',
            submittip3: 'Veuillez procéder à une série de certifications telles que le mot de passe du fonds',
            submittip4: 'Veuillez lier au moins un mode de paiement',
        },
        index: {
            title: 'Bonnes recommandations publicitaires',
            exchangetimes: 'Nombre de transactions',
            exchangeprice: 'Prix de transaction',
            exchangelimit: 'Limite de transaction',
            paymode: 'Mode de paiement',
            buy: 'acheter',
            sell: 'vendre',
            viewmore: 'Plus',
            bot1: 'Sûr et fiable',
            bot1_tip: 'Plus de 10 ans d\'expérience dans l\'équipe de contrôle des risques financiers\nSystème de politique de sécurité personnalisable',
            bot2: 'Rapide et facile',
            bot2_tip: 'Mode de transaction libre entre utilisateurs pair à pair\nDivers canaux d\'échange de devises',
            bot3: 'Toutes les devises',
            bot3_tip: 'Sélection de devises de transaction d\'actifs numériques grand public\nExpérience de trading multi-actifs',
            ibuy: 'Je veux acheter',
            isell: 'Je veux vendre',
        }
    },
    activity: {
        all: "Tout",
        prepare: "À venir",
        ongoing: "En cours",
        distributing: "Distribution",
        completed: "Terminé",
        progress: "Progression",
        totalsupply: "Offre totale",
        starttime: "Date de début",
        endtime: "Date de fin",
        viewdetail: "Détail",
        attend: "Participer",
        tokendistribute: "Distribution de jetons",
        baseinfo: "Infos de l'activité",
        status: "Statut",
        activitytype: "Type d'activité",
        activitytype0: "Inconnu",
        activitytype1: "Listing (FOF)",
        activitytype2: "Listing (AVA)",
        activitytype3: "Distribution aux détenteurs",
        activitytype4: "Achat gratuit",
        activitytype5: "Achat minier",
        activitytype6: "Verrouillé",
        ruledetail: "À propos des règles",
        publishprice: "Prix de publication",
        activitycoin: "Symbole de la devise de l'activité",
        accpetcoin: "Symbole de la devise acceptée",
        holdcoin: "Symbole de la devise détenue",
        limittimes: "Limite personnelle de fois",
        limitamount: "Limite personnelle de montant",
        unlimited: "Illimité",
        alreadyamount: "Montant déjà vendu",
        leftamount: "Montant restant",
        attention: "Attention",
        attentiontxt1: "1. Les actifs seront gelés après la soumission pour participation aux activités de type [partition d'entrepôt] et [souscription gratuite] jusqu'à ce que le dégel soit terminé.",
        attentiontxt2: "2. Les utilisateurs ne peuvent pas retirer leur demande de participation après avoir participé aux activités de type 'Distribution aux détenteurs' et 'Achat gratuit'",
        attentiontxt3: "3. Si l'activité est annulée en raison du projet ou d'autres facteurs de force majeure, les actifs gelés seront retournés par la voie originale.",
        attentiontxt4: "* Le droit d'interprétation finale de cette activité appartient à BIPPAX.",
        inputamount: "Entrer le montant",
        inputholdamount: "Entrer le montant de verrouillage",
        mybalance: "Solde disponible",
        holdtips: "[Distribution aux détenteurs] nécessite un verrouillage jusqu'à la fin de l'activité.",
        pleaseinputamount: "Veuillez entrer le montant !",
        pleaseinputholdamount: "Veuillez entrer le montant de détention !",
        commitfailed: "Échec de la soumission !",
        minlimitamountfailed: "La quantité d'échange ne doit pas être inférieure au montant minimum d'échange !",
        maxlimitamountfailed: "Le montant d'échange ne doit pas être supérieur au montant maximum d'achat !",
        limittimesfailed: "Vous avez dépassé le nombre maximum d'achats individuels !",
        balancenotenough: "Le solde est insuffisant !",
        headertitledesc: "Laboratoires ouverts pour une coopération gagnant-gagnant entre investisseurs, porteurs de projets et plateformes d'échange",
        currentdivided: "Ma position actuelle recevra",
        leveloneCount: "Limite de comptage niveau un",
        submit: "Soumettre",
        tipsmobile: "Veuillez utiliser le site PC (www.BIPPAX.com)",
        tipsmobile1: "Vous pouvez accéder au site PC pour participer à cette activité.",
        intvalue: "Veuillez entrer une valeur entière",
        inputminingamount: "Entrer le nombre d'achats",
        moreactivity: "Plus d'activités",
        releaseType: "Type de libération",
        releaseType0: "Libération égale",
        releaseType1: "Libération isométrique",
        lock: "Verrouillage ",
        releaseDetail: "Détail de libération",
        lockday: " Jours",
        lockweek: " Semaines",
        lockmonth: " Mois",
        lockyear: " Ans",
        releasePercent: "Pourcentage de libération",
        lockFee: "Frais de verrouillage",
        releaseTimes: "Nombre de libérations",
        times: "fois"
    },
    invite: {
        myinvitelink: "Lien de promotion",
        copy: "Copier",
        copyed: "Copié",
        mylevelone: "Amis de niveau un",
        myleveltwo: "Amis de niveau deux",
        mycommission: "Revenus de commission (USDT)",
        extrareward: "Récompenses supplémentaires",
        partnerlevel: "Niveau de partenariat",
        ruledetail: "Détails des règles",
        ruleprofile1: "[Partenaire de promotion] est le programme offrant la plus haute proportion de commission en ligne et la plus longue durée de commission (commission à vie maximum). Les promoteurs qui font les efforts correspondants peuvent devenir de véritables 'partenaires' de la plateforme et profiter des dividendes de croissance avec la plateforme de trading BIPPAX. Les règles détaillées sont les suivantes :",
        ruleprofile2: "",
        ruleprofile3: "",
        ruleprofile4: "",
        ruletext1: "1. Afin de promouvoir le concept des actifs numériques et d'élargir la base d'utilisateurs, BIPPAX a lancé le programme 'Partenaire de promotion', qui est valable à long terme.",
        ruletext2: "2. L'invitation d'amis peut être divisée en deux niveaux. Si A invite B, alors B est l'ami de premier niveau de A. Si B invite C, alors C appartient à l'ami de premier niveau de B et aussi à l'ami de deuxième niveau de A.",
        ruletext3: "3. Lors de la promotion de l'inscription d'amis, les amis de premier niveau des invitants ne peuvent être que les amis de premier niveau des invitants par les liens fournis par les invitants ou en entrant manuellement les codes d'invitation des invitants.",
        ruletext4: "4. Après que l'invité s'inscrit avec le code d'invitation de l'invitant et complète la certification d'identité réelle, l'incitation de commission prendra effet.",
        ruletext5: "5. La durée de la commission est de N mois à partir du début de la certification d'identité réelle de l'invité. Selon les différents grades, la proportion de commission est différente.",
        ruletext6: "6. Les actifs de commission de promotion sont les frais de transaction de devises des amis de niveau inférieur, qui sont les trois devises de base du marché, à savoir USDT, BTC et ETH.",
        ruletext7: "7. La proportion et la durée de la commission de promotion sont positivement corrélées au nombre d'amis de premier niveau. Plus le nombre de promotions est élevé, plus la proportion de commission est élevée. Le ratio de remise de commission de promotion spécifique est le suivant :",
        ruletext8: "8. Le TOP10 ou TOP100 recevra des récompenses supplémentaires de MKWORLDS de temps en temps.",
        ruletext9: "9. Si d'autres activités sont en conflit avec les activités du partenaire de promotion, les partenaires sont priés de comprendre si un changement temporaire est nécessaire après consultation.",
        ruletext10: "10. Les partenaires de niveau L4 (Xunfu), L5 (Taishou) et L6 (Jiedushi) ont droit respectivement à des bonus de 5%, 10% et 15% du total annuel des retours de commission.",
        ruletext11: "11. Le droit d'interprétation finale de cette activité appartient à BIPPAX.",
        ruleexampletitle: "Par exemple :",
        ruleexamplecontent1: "Si l'utilisateur Xiaoyan a invité 100 amis de premier niveau, et que ses amis de premier niveau ont invité cinq amis de deuxième niveau, alors Xiaoyan a 100 amis de premier niveau et 500 amis de deuxième niveau. Si la personne moyenne trade 3000 yuans par jour, le revenu mensuel de Xiaoyan est d'environ (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%) * 30 = 7200 / mois.",
        ruleexamplecontent2: "Si l'utilisateur Xiaoyan a invité 1000 amis de premier niveau, et que ses amis de premier niveau ont invité 5 amis de deuxième niveau, Xiaoyan a 1000 amis de premier niveau et 5000 amis de deuxième niveau. Si la personne moyenne trade 3000 yuans par jour, le revenu mensuel de Xiaoyan est d'environ (1000*3000*0,001*50%+5000*3000*0,001*20%)*30=135000/mois.",
        lastupdate: "Dernière mise à jour le",
        laststastic: "Dernière statistique le",
        level: "Niveau",
        lv1: "Lizheng",
        lv2: "Xianling",
        lv3: "Zhifu",
        lv4: "Xunfu",
        lv5: "Taishou",
        lv6: "Jiedushi",
        levelonecount: "Nombre de niveau un",
        levelonecommission: "Ratio/Durée de retour niveau un",
        leveltwocommission: "Ratio/Durée de retour niveau deux",
        partnerdivide: "Dividende du partenaire",
        month: "Mois",
        alllife: "À vie",
        totalcommissionrank: "Commission totale de promotion",
        rank: "N°",
        userid: "ID utilisateur",
        rankday: "(Jour)",
        rankweek: "(Semaine)",
        rankmonth: "(Mois)",
        rankall: "(Tout)",
        promotioncount: "Nombre de promotions",
        commissionusdt: "Commission (USDT)",
        ranktip1: "Le nombre d'invitations est le nombre d'amis de premier niveau. Cette liste classe le montant total des commissions du plus élevé au plus bas.",
        ranktip2: "Le nombre d'invitations est le nombre d'amis de premier niveau. La liste est classée par le nombre d'amis de premier niveau invités.",
        thanks: "Merci de soutenir BIPPAX !",
        headertip: "Les données ci-dessus ne sont pas mises à jour en temps réel. Le système compile les statistiques et les mises à jour toutes les 24H.",
        ptools: "Outils de promotion",
        pt_title: "Carte cadeau de cryptomonnaie",
        pt_desc: "C'est une surprise du futur, à envoyer à des amis, parents, clients, partenaires.",
        pt_more: "Plus d'outils à venir",
        pt_tips: "Si vous avez une bonne idée, veuillez envoyer un e-mail à promotion@BIPPAX.com, avec une récompense après adoption !",
        pt_card_amount: "Montant de la carte",
        pt_card_deadline: "Date limite",
        pt_card_noend: "Indéterminée",
        pt_card_btn: "Obtenez 30 cartes gratuitement (≈2000 CNY)",
        pt_card_btn_login: "Veuillez d'abord vous connecter",
        pt_card_rule: "Détails des règles",
        pt_card_summary: "La carte cadeau de monnaie numérique est un outil de promotion développé pour permettre aux partenaires de promotion de mieux inviter des amis hors ligne. Lorsque les utilisateurs échangent des cartes cadeaux, ils deviennent automatiquement des amis hors ligne des partenaires de promotion.",
        pt_card_rule1: "1. Les cartes cadeaux gratuites sont limitées à 30 cartes par utilisateur. Si plus de cartes cadeaux doivent être émises, les utilisateurs doivent payer pour la personnalisation, qui peut personnaliser le montant des cartes, le LOGO, les instructions, etc. Pour les exigences personnalisées, veuillez envoyer un e-mail à",
        pt_card_rule2: "2. Les cartes cadeaux gratuites sont limitées à une copie par utilisateur. Les cartes cadeaux gratuites émises par le gouvernement BIPPAX sont limitées à une pour chaque utilisateur. Même si différents utilisateurs reçoivent des cartes cadeaux gratuites avec différents codes d'échange, un seul peut être échangé. Les cartes cadeaux personnalisées ne sont pas soumises à cette restriction.",
        pt_card_rule3: "3. Avant que l'utilisateur n'échange la carte cadeau, s'il n'y a pas d'« invitant » (c'est-à-dire que le code d'invitation n'a pas été entré lors de l'inscription du compte), il sera automatiquement associé à l'ami de premier niveau de l'émetteur de la carte.",
        pt_card_rule4: "4. Afin de prévenir les abus, la valeur comptable des cartes cadeaux n'est pas payée en temps réel. Elle sera gelée pendant 180 jours après la collecte et libérée automatiquement dans le solde du compte utilisateur après 180 jours.",
        pt_card_rule5: "5. Lors de la réception de cartes cadeaux gratuites, nous devons compléter la certification d'identité réelle. Lors de la conversion, nous pouvons les obtenir sans compléter la certification d'identité réelle.",
        pt_card_rule6: "6. Le droit d'interprétation finale des cartes cadeaux gratuites appartient à BIPPAX.PRO.",
        pt_card_day: "Jours",
        pt_card_title_tips: "Subvention de promotion gratuite de 2000 CNY",
        pt_card_receivew_success: "Félicitations ! Collecte réussie de la carte cadeau de promotion partenaire ! Veuillez aller au Centre personnel -> Centre de cartes et bons.",
        usepromotion: "Utiliser les matériaux promotionnels",
        saveimage: "Enregistrer l'image",
        imagetips: "Si vous ne pouvez pas télécharger les images correctement, veuillez les télécharger à l'aide de l'outil de capture d'écran !",
        pt_invite_title: "Dépliant d'inscription par invitation",
        pt_invite_desc: "Devenez automatiquement un ami subordonné par l'inscription par code QR, adapté au transfert dans divers groupes ou forums.",
        colum_text0: "Rang",
        colum_text1: "Membre",
        colum_text2: "Promotion",
        colum_text3: "Commission (USDT)",
        colum_text4: "Récompense supplémentaire",
        context_title: "Code d'échange exclusif pour les partenaires de promotion",
        context_title1: "Scannez pour en savoir plus",
        context_title2: "Mon code d'invitation",
        context_title3: "Image d'invitation"
    },
    uc: {
        verify: "Complétez d'abord le KYC",
        login: {
            noaccount: 'Pas de compte ?',
            register: 'Inscription',
            login: 'Connexion',
            welcomelogin: 'Bienvenue',
            usertip: 'Veuillez entrer l\'e-mail',
            pwdtip: 'Entrez le mot de passe',
            validatecodeload: 'Chargement du code de vérification',
            validatemsg: 'Veuillez d\'abord terminer la vérification',
            forget: 'Mot de passe oublié ?',
            loginvalidate: 'Veuillez entrer l\'e-mail ou le numéro de téléphone',
            pwdvalidate1: 'Veuillez entrer le mot de passe',
            pwdvalidate2: 'Le mot de passe doit contenir au moins six caractères',
            success: 'Succès',
            goregister: "S'inscrire",
            getlostpwd: "Mot de passe oublié"
        },
        forget: {
            title: "Retrouver le mot de passe",
            hasaccount: 'Vous avez un compte ? Se connecter',
            login: 'Connexion',
            sendcode: 'Envoyer',
            newpwd: 'Entrez le nouveau mot de passe',
            confirmpwd: 'Entrez à nouveau le nouveau mot de passe',
            save: 'Soumettre',
            pwdvalidate1: 'Entrez le mot de passe de confirmation',
            pwdvalidate2: 'Les mots de passe ne correspondent pas !',
            resettelpwd: 'Réinitialiser le mot de passe par téléphone',
            resetemailpwd: 'Réinitialiser le mot de passe par e-mail',
            newpwdtip: 'Entrez le nouveau mot de passe',
            pwdvalidate3: 'Le mot de passe doit contenir au moins six caractères',
            telno: 'Numéro de téléphone',
            mtelno: 'Authentification par téléphone mobile',
            memail: 'Authentification par e-mail',
            smscode: 'Code de vérification SMS',
            teltip: 'Entrez le téléphone',
            smscodetip: 'Entrez le code de vérification SMS',
            email: 'E-mail',
            emailcode: 'Code de vérification e-mail',
            emailtip: 'Entrez l\'e-mail',
            emailcodetip: 'Entrez le code de vérification e-mail',
            resetpwdsuccess: 'Réinitialisation du mot de passe réussie',
            smswarn: 'Veuillez vérifier les SMS',
        },
        finance: {
            fi1: 'Masquer les petits actifs',
            center: 'Centre financier',
            personalassets: 'Actifs en devises',
            swapassets: 'Actifs Swap',
            billdetail: 'Détail de la facture',
            charge: 'Dépôt',
            pickup: 'Retrait',
            tradetail: 'Mining de trading',
            paydividends: 'Payer les dividendes',
            invitingmining: 'Récompenses de mining par invitation',
            money: {
                M1: 'Quantité reçue',

                M2: 'Quantité transférée',

                M3: 'Taux de change',
                cointype: 'Devise',
                balance: 'Solde',
                frozen: 'Solde gelé',
                operate: 'Action',
                charge: 'Dépôt',
                pickup: 'Retrait',
                onkeytrans: "Transfert",
                getaddress: 'Obtenir l\'adresse',
                resetsuccess: 'Réinitialisation réussie',
                match: 'Correspondance',
                matchtip1: 'Montant GCX de correspondance disponible',
                matchtip2: 'Entrer le montant de correspondance',
                matcherr1: 'Veuillez entrer une quantité valide !',
                matcherr2: 'Dépasse le nombre maximum de correspondances !',
                matchsuccess: 'Correspondance réussie !',
                needreleased: "Actifs à libérer",
                totalassets: "Valeur totale estimée des actifs :"
            },
            swap: {
                totalassets: "Valeur totale estimée des actifs :",
                swap: " Swap",
                swaptype: 'SWAP',
                swapassets: "Capitaux propres du compte",
                avabalance: "Marge disponible",
                usebalance: "Marge utilisée",
                frozenbalance: "Marge gelée",
                profitandloss: "P/L non réalisé",
                transfor: "Transfert",
                inputtransferamount: "Montant du transfert",
                all: "Tout",
                currencyaccount: "Compte au comptant",
                swapaccount: "Compte Swap perpétuel",
                clickchange: "Cliquer pour changer la direction",
                avaamount: "Disponible",
                pleaseselectwallet: "Veuillez d'abord choisir un portefeuille de transfert.",
                pleaseinputamount: "Veuillez entrer le montant du transfert",
                oktransfer: "Transférer maintenant"
            },
            trade: {
                start_end: 'Début-Fin',
                account_date: 'Date de réception des fonds',
                to: 'À',
                operatetype: 'Type d\'action',
                search: 'Rechercher',
                charge: 'Dépôt',
                pickup: 'Retrait',
                transaccount: 'Transfert',
                exchange: 'Échange',
                otcbuy: 'OTC-Achat',
                otcsell: 'OTC-Vente',
                activityaward: 'Récompense d\'activité',
                promotionaward: 'Récompense de promotion',
                dividend: 'Dividende',
                vote: 'Vote',
                handrecharge: 'Recharge manuelle',
                match: 'Correspondance',
                activitybuy: "Achat d'activité",
                ctcbuy: "CTC-Achat",
                ctcsell: "CTC-Vente",
                chargetime: 'Date de génération de la commande',
                type: 'Type',
                num: 'Montant',
                status: 'Statut',
                finish: 'Terminé',
                fee: 'Retour des frais de mining',
                transactionTime: 'Heure de transaction',
                symbol: 'Paire de devises',
                direction: 'Direction',
                price: 'Prix',
                entrustment: 'Ordre confié',
                havedeal: 'Transaction effectuée',
                poundageAmount: 'Frais de service',
                exchangeOrderId: "ID de commande",
                mineAmount: "Devise minée (BHB)",
                buy: "ACHAT",
                sell: "VENTE",
                limit: "LIMITÉ",
                market: "MARCHÉ",
                clear: "Effacer les conditions",
                turnover: "Chiffre d'affaires"
            },
            paydividende: {
                money_holding: 'Dividendes accumulés retournés (ETH) : ',
                money_hold: 'Dividendes à retourner (ETH) : ',
                paydividends: 'Payer les dividendes (ETH)',
                account_date: 'Date de réception des fonds',
                datehodld: 'Date de détention',
                start_end: 'Début-Fin',
                to: 'À',
                operatetype: 'Type d\'action',
                search: 'Rechercher',
                charge: 'Dépôt',
                pickup: 'Retrait',
                transaccount: 'Transfert',
                exchange: 'Échange',
                otcbuy: 'OTC-Achat',
                otcsell: 'OTC-Vente',
                activityaward: 'Récompense d\'activité',
                promotionaward: 'Récompense de promotion',
                dividend: 'Dividende',
                vote: 'Vote',
                handrecharge: 'Recharge manuelle',
                match: 'Correspondance',
                chargetime: 'Heure de recharge',
                type: 'Type',
                num: 'Montant',
                status: 'Statut',
                finish: 'Terminé',
                fee: 'Frais',
                symbol: 'Symbole de la devise',
            },
            record: {
                Please: 'Veuillez sélectionner la plage de dates de recherche',
                start_end: 'Début-Fin',
                to: 'À',
                operatetype: 'Type d\'action',
                search: 'Rechercher',
                charge: 'Dépôt',
                pickup: 'Retrait',
                transaccount: 'Transfert',
                exchange: 'Échange',
                otcbuy: 'OTC-Achat',
                otcsell: 'OTC-Vente',
                activityaward: 'Récompense d\'activité',
                promotionaward: 'Récompense de promotion',
                dividend: 'Dividende',
                vote: 'Vote',
                handrecharge: 'Recharge manuelle',
                match: 'Correspondance',
                chargetime: 'Heure de recharge',
                type: 'Type',
                num: 'Montant',
                status: 'Statut',
                finish: 'Terminé',
                fee: 'Frais',
                shouldfee: 'Frais à payer',
                revenue: 'Type de revenus et dépenses',
                re1: 'Entrée',
                re2: 'Sortie',
                discountfee: 'Frais de déduction',
                realfee: 'Frais de service',
                symbol: 'Symbole de la devise',
                activitybuy: "Achat d'activité",
                ctcbuy: "C2C ACHAT",
                ctcsell: "C2C VENTE",
                redout: "ENVOI ENVELOPPE",
                redin: "RÉCEPTION ENVELOPPE",
                quickExchange: "Échange rapide",
                currentRate: "Taux de change actuel",
                from: "De",
                inputexchangeamount: "Entrer le montant de l'échange rapide",
                inputexchangepasswd: "Entrer le mot de passe d'échange",
                chooseTransCoinUnit: "Choisir la devise de transfert",
                inputTransAmount: "Choisir le montant de transfert",
                predictAmount: "Sera échangé",
                qamount: "Montant",
                qrate: "Taux",
                qexamount: "Montant d'échange",
                withdrawcodein: "Recharge par code de retrait",
                withdrawcodeout: "Retrait par code",
                contractfee: "Frais de Swap",
                contractprofit: "Profit de Swap",
                contractloss: "Perte de Swap",
                optionfail: "Échec d'option",
                optionfee: "Frais d'option",
                optionreward: "Récompense d'option",
                other: "Autre"
            },
            recharge: {
                recharge: 'Dépôt',
                symbol: 'Devise',
                address: 'Adresse de dépôt',
                copy: 'Copier',
                qrcode: 'Code QR',
                qrcodeaddress: 'Code QR pour le dépôt',
                msg1: 'Ne rechargez aucun actif non monétaire à l\'adresse ci-dessus, sinon les actifs ne seront pas récupérés.',
                msg2: 'Après avoir rechargé à l\'adresse ci-dessus, vous devez confirmer l\'ensemble du nœud réseau, après 2 confirmations réseau, après 6 confirmations réseau, vous pouvez retirer.',
                msg3: 'Montant minimum de recharge : ',
                msgtop: 'Cette adresse est uniquement pour la recharge de ',
                msg3_1: ", une recharge inférieure au montant minimum ne sera pas créditée.",
                msg4: 'Votre adresse de recharge ne changera pas fréquemment et vous pouvez répéter la recharge ; en cas de changement, nous essaierons de vous notifier via une annonce du site ou un e-mail.',
                msg5: 'Veuillez vous assurer de confirmer la sécurité de votre ordinateur et de votre navigateur pour empêcher la falsification ou la fuite d\'informations.',
                record: 'Historique',
                copysuccess: 'Succès !',
                copyerr: 'Échec ! Veuillez copier manuellement',
                time: 'Heure d\'arrivée',
                amount: 'Montant',
                gettingaddress: "Obtention de l'adresse de dépôt, veuillez patienter...",
                getaddress: "Obtenir l'adresse de dépôt",
                memotips: "Veuillez entrer ce mémo lors de la recharge, sinon vous perdrez des actifs.",
                withdrawrecharge: "Recharger par code",
                coderechargetip: "Veuillez entrer le code de retrait",
                rechargesuccess: "Félicitations, recharge réussie !",
                rechargeconfirm: "Confirmation de recharge",
                status: "Statut"
            },
            withdraw: {
                pickup: 'Retrait',
                addressmanager: 'Gestion des adresses',
                withdrawbycode: 'Retirer par code',
                withdrawcode: 'Code de retrait',
                symbol: 'Devise',
                address: 'Adresse',
                num: 'Montant',
                avabalance: 'Solde disponible',
                msg1: 'Le montant des devises est inférieur à',
                msg2: 'Crédit automatique au compte, sinon un examen manuel est requis',
                increase: 'Augmenter le crédit',
                tip1: 'Entrez au maximum ',
                tip11: 'décimales et la valeur minimale est',
                tip2: 'La valeur maximale est',
                numtip1: 'Entrez le nombre de devises',
                fee: 'Frais',
                range: 'Plage',
                arriamount: 'Nombre d\'arrivées',
                msg3: 'Le nombre minimum de devises est',
                msg4: 'devise',
                msg5: 'Afin d\'assurer la sécurité des fonds, lorsque votre politique de sécurité de compte change, que les mots de passe sont modifiés et que vous utilisez la nouvelle adresse pour retirer des devises, nous effectuerons un audit manuel. Veuillez patienter et attendre que le personnel vous appelle ou vous envoie un e-mail.',
                msg6: 'Veuillez vous assurer de confirmer la sécurité de votre ordinateur et de votre navigateur pour empêcher la falsification ou la fuite d\'informations.',
                record: 'Historique des retraits',
                symboltip: 'Veuillez sélectionner une devise',
                addresstip: 'Veuillez remplir l\'adresse',
                numtip2: 'Veuillez remplir le nombre correct de devises, la valeur minimale est',
                numtip3: 'Le montant de retrait ne doit pas être inférieur aux frais de traitement',
                amounttip: 'Veuillez entrer le montant',
                feetip1: 'Les frais minimaux sont',
                feetip2: 'La valeur maximale est',
                time: 'Heure de retrait',
                status: 'Statut',
                status_1: 'En cours d\'examen',
                status_2: 'En cours de transfert',
                status_3: 'Échec',
                status_4: 'Succès',
                St5: 'Prix de liquidation estimé',
                St6: 'Actifs totaux = solde du portefeuille + non réalisé',
                St7: 'P/L non réalisé = P/L non réalisé calculé en utilisant le dernier prix pour tous les contrats détenus',
                St8: 'Solde du portefeuille = transferts entrants - transferts sortants - gains et pertes réalisés',
                St9: 'Rejeté',
                remark: 'Remarque',
                add: 'Ajouter',
                addresslist: 'Liste d\'adresses',
                safevalidate: 'Vérification de sécurité',
                telno: 'Téléphone',
                mtelno: 'Authentification par téléphone mobile',
                memail: 'Authentification par e-mail',
                smscode: 'Code de vérification par téléphone',
                second: 'seconde',
                clickget: 'Obtenir',
                email: 'E-mail',
                emailcode: 'Code de vérification e-mail',
                save: 'Enregistrer',
                delete: 'Supprimer',
                telerr: 'Numéro de téléphone incorrect',
                emailerr: 'E-mail incorrect',
                codeerr: 'Code de vérification incorrect',
                remarktip: 'Entrez la remarque',
                savemsg1: 'Échec de l\'enregistrement !',
                savemsg2: 'Enregistré avec succès !',
                operate: 'Opération',
                fundpwdtip: 'Veuillez entrer le mot de passe du fonds',
                click: 'cliquer',
                filtrate: 'peut filtrer',
                txid: "TxId",
                generateCode: "Générer un code de retrait",
                withdrawcodelist: "Liste des codes de retrait",
                withdrawcodestatus: "Statut",
                submit: "Soumettre",
                generatecodesuccess: "Code de retrait généré !",
                wi1: 'Réseau',
                wi2: 'Authentification de sécurité',
                wi3: 'Montant reçu',
                wi4: 'Adresse de réception',
                wi5: 'Réseau de retrait',
                wi6: 'Montant total du retrait',
                wi7: 'Frais de réseau',
                wi8: 'Veuillez vous assurer d\'avoir entré la bonne adresse de retrait et que le réseau de retrait sélectionné correspond à l\'adresse',
                wi9: 'Les ordres de retrait ne peuvent pas être annulés après création',
                wi10: 'Continuer',
                wi11: 'Mot de passe du fonds',
                wi12: 'code de vérification mobile',
                wi13: 'Envoyer',
                wi14: 'Code',
                wi15: 'Envoyer',
                wi16: 'Soumettre',
            }
        },
        member: {
            usercenter: "Profil utilisateur",
            securitycenter: 'Centre de sécurité',
            securitysetting: 'Paramètres de sécurité',
            accountsetting: 'Paramètres du compte',
            account: "Compte",
            assets: "Finance",
            exchange: "Échange",
            curdelegate: "Ordres en cours",
            hisdelegate: "Historique des ordres",
            otc: "OTC"
        },
        order: {
            ordercenter: 'Centre de commandes',
            myorder: 'Mes commandes',
            myad: 'Mes annonces',
        },
        regist: {
            Res1: 'Le nom d\'utilisateur est composé de lettres majuscules, minuscules et de chiffres, et doit contenir des lettres',
            hasaccount: 'Vous avez un compte ? Se connecter',
            login: 'Connexion',
            username: 'Nom d\'utilisateur',
            country: 'Pays',
            smscode: 'Code de vérification SMS',
            sendcode: 'Envoyer',
            resendcode: "Renvoyer(",
            pwd: 'Mot de passe',
            repwd: 'Confirmer le mot de passe',
            confrimpwd: 'Confirmer le mot de passe',
            agreement: 'J\'ai lu et j\'accepte',
            userprotocol: 'Accord de l\'utilisateur',
            regist: 'Inscription',
            teltip: 'Entrez le téléphone',
            telerr: 'Erreur de format de téléphone, entrez à nouveau',
            emailtip: 'Entrez l\'e-mail',
            emailerr: 'Erreur de format d\'e-mail, entrez à nouveau',
            confirmpwdtip: 'Entrez le mot de passe de confirmation',
            confirmpwderr: 'Les deux mots de passe ne correspondent pas !',
            telregist: 'Inscription par téléphone',
            emailregist: 'Inscription par e-mail',
            usernametip: 'Entrez le nom d\'utilisateur',
            usernamemsg: 'Le nom d\'utilisateur doit contenir entre 3 et 15 caractères',
            countrytip: 'Sélectionnez le pays',
            smscodetip: 'Entrez le code de vérification SMS',
            pwdtip: 'Entrez le mot de passe de connexion',
            pwdmsg: 'Le mot de passe doit contenir au moins 6 caractères',
            telno: 'Téléphone',
            email: 'E-mail',
            agreementtip: 'Cliquez pour accepter',
            modaltitle: 'Veuillez vérifier',
            promotion: 'Code d\'invitation',
            china: 'Chine',
            singapore: 'Singapour',
            korea: 'Corée',
            japan: 'Japon',
            thailand: 'Thaïlande',
            russia: 'Russie',
            uk: 'Royaume-Uni',
            vietnam: 'Vietnam',
            india: 'Inde',
            italy: 'Italie',
            hk: 'Hong Kong',
            malaysia: 'Malaisie',
            taiwan: 'Taïwan',
            turkey: 'Turquie',
            germany: 'Allemagne',
            france: 'France',
            spain: 'Espagne',
            us: 'États-Unis',
        },
        safe: {
            Ad1: 'Veuillez télécharger votre carte de sécurité sociale, permis de conduire ou passeport',
            Ad2: 'Téléchargez l\'un des fichiers avant la soumission',
            Ad3: 'Nom complet',
            Ad4: 'Adresse de contact',
            Ad5: 'Diffusion en direct',
            Ad6: 'Mon direct',
            Ad7: 'Échec de l\'ajout, maximum de 3 peut être ajouté',
            size: 'La taille de l\'image téléchargée ne peut pas dépasser 5 Mo',
            safelevel_low: 'Niveau de sécurité : Faible',
            safelevel_high: 'Niveau de sécurité : Élevé',
            safelevel_medium: 'Niveau de sécurité : Moyen',
            nickname: 'Surnom',
            bind: 'Lier',
            binded: 'Lié',
            verifypass: "Vérifié",
            binding: 'Liaison en cours',
            binderr: 'Échec',
            bindretry: 'Réessayer',
            verified: 'Vérifié',
            notverified: "Non vérifié",
            verifiedtip: 'Pour protéger la sécurité de votre compte, veuillez compléter la certification d\'identité réelle avant de pouvoir effectuer des opérations de trading !',
            realname: 'Nom réel',
            idcard: 'Carte d\'identité',
            upload: 'Télécharger',
            upload_positive: 'Télécharger le recto de la carte d\'identité',
            upload_negative: 'Télécharger le verso de la carte d\'identité',
            upload_hand: 'Télécharger la photo avec carte d\'identité en main',
            save: 'Enregistrer',
            reset: 'Réinitialiser',
            email: 'E-mail',
            bindemail: 'Lier l\'e-mail',
            loginpwd: 'Mot de passe de connexion',
            emailcode: 'Code de vérification e-mail',
            clickget: 'Cliquer pour obtenir',
            second: 's',
            phone: 'Téléphone',
            bindphone: 'Lier le téléphone',
            phonecode: 'Code de vérification téléphone',
            logintip: 'Utilisé lors de la connexion à la plateforme',
            edit: 'Modifier',
            oldpwd: 'Ancien mot de passe de connexion',
            newpwd: 'Nouveau mot de passe de connexion',
            confirmnewpwd: 'Confirmer le nouveau mot de passe',
            fundpwd: 'Mot de passe du fonds',
            fundtip: 'Lorsque les fonds du compte changent, vous devez d\'abord vérifier le mot de passe du fonds',
            set: 'Paramétrer',
            confirmpwd: 'confirmer le mot de passe',
            oldfundpwd: 'Ancien mot de passe du fonds',
            newfundpwd: 'Nouveau mot de passe du fonds',
            newpwdmsg1: 'Veuillez entrer au moins 6 caractères pour le nouveau mot de passe de connexion',
            newpwdmsg2: 'Le nouveau mot de passe de connexion ne correspond pas',
            pwdmsg1: 'Veuillez entrer au moins 6 caractères pour le mot de passe',
            pwdmsg2: 'Mot de passe incohérent',
            emailtip: 'Veuillez entrer l\'e-mail',
            codetip: 'Veuillez entrer le code de vérification',
            telnotip: 'Veuillez entrer le numéro de téléphone',
            oldpwdtip: 'Veuillez entrer le mot de passe original',
            realnametip: 'Veuillez entrer votre nom réel',
            idcardtip: 'Veuillez entrer le numéro de carte d\'identité',
            bindphonetip: 'Veuillez d\'abord lier votre téléphone !',
            resetfundpwd: 'Réinitialiser le mot de passe du fonds',
            upload_positivetip: 'Veuillez télécharger le recto de la carte d\'identité',
            upload_negativetip: 'Veuillez télécharger le verso de la carte d\'identité',
            upload_handtip: 'Veuillez télécharger la photo avec carte d\'identité en main',
            save_success: 'Succès !',
            save_failure: 'Échec !',
            imgtip: 'Veuillez télécharger votre code QR pour recevoir des fonds',
            idcard_verifymsg1: "1. Le fichier doit être inférieur à 8 Mo. Les informations sur le document doivent être clairement visibles, aucune modification du document ou couverture par des objets étrangers n'est autorisée, et le numéro du document et le nom doivent être visibles.",
            idcard_verifymsg2: "2. La photographie doit vous montrer sans chapeau. Il est recommandé de ne pas avoir de maquillage. Les traits du visage du titulaire du document doivent être clairs, et les bras doivent être complètement exposés.",
            idcard_verifymsg3: "3. Vous devez tenir à la fois le document et une copie manuscrite (nom + date de demande), 'Toutes mes actions sur ce site sont mes propres opérations, et je comprends les risques impliqués et je suis prêt à assumer toutes les conséquences juridiques de ce compte.'"
        },
        account: {
            pagetitle: 'Lier un compte à nom réel',
            pagetip: 'Veuillez configurer votre mode de paiement, veuillez utiliser votre compte à nom réel',
            backcardno: 'Compte bancaire',
            backcardtip: 'Les informations de la carte bancaire personnelle ne sont pas liées',
            modify: 'Modifier',
            bind: 'Lier',
            name: 'Nom',
            bankaccount: 'Compte bancaire',
            bankbranch: 'Agence bancaire',
            bankno: 'Numéro de banque',
            confirmbankno: 'Confirmer le numéro de carte',
            fundpwd: 'Mot de passe du fonds',
            save: 'Enregistrer',
            zfbaccount: 'Compte Alipay',
            zfbaccounttip: 'Le compte Alipay personnel n\'est pas lié',
            wxaccount: 'Compte Wechat',
            wxaccounttip: 'Le compte Wechat personnel n\'est pas lié',
            banknomsg1: 'Veuillez entrer le bon numéro de carte bancaire',
            banknomsg2: 'Les numéros de carte bancaire saisis ne correspondent pas !',
            verifiedmsg: 'Veuillez d\'abord effectuer la certification d\'identité réelle',
            bankaccountmsg: 'Veuillez sélectionner votre banque',
            bankbranchmsg: 'Veuillez entrer l\'agence du compte',
            banknomsg: 'Veuillez entrer le bon numéro de carte bancaire',
            fundpwdmsg1: 'Veuillez entrer le bon mot de passe du fonds',
            fundpwdmsg2: 'Le mot de passe ne peut pas être inférieur à 6 caractères',
            zfbaccountmsg: 'Veuillez entrer le compte Alipay',
            wxaccountmsg: 'Veuillez entrer le compte WeChat',
            save_success: 'Succès !',
            save_failure: 'Échec !',
        },
        otcorder: {
            unpaid: 'Non payé',
            paided: 'Payé',
            finished: 'Terminé',
            canceled: 'Annulé',
            appealing: 'En recours',
            searchtip: 'Entrez le numéro de commande',
            orderno: 'N° de commande',
            created: 'Date',
            symbol: 'Devise',
            type: 'Type',
            type_sell: 'vendre',
            type_buy: 'acheter',
            tradename: 'Nom du trade',
            amount: 'Montant',
            money: 'Argent',
            fee: 'Frais',
        },
        identity: {
            certified: "déjà certifié",
            placeholder: "Veuillez remplir la raison de l'annulation",
            apply: 'Postuler pour devenir marchand',
            become: "Devenez un marchand certifié BIPPAX et profitez de plus de privilèges de transaction",
            zhusnhu: "Les marchands bénéficient de stands publicitaires exclusifs pour augmenter le succès des transactions",
            tijiaoziliao: "Soumettre les informations d'authentification du marchand",
            place: "Veuillez télécharger les informations d'authentification du marchand préparées sur la plateforme et les soumettre",
            tijiao: "Votre audit de certification de marchand a été soumis",
            tijiaosuc: "Félicitations ! Votre certification de marchand a été approuvée",
            tijiaofail: "Désolé ! Votre certification de marchand n'a pas été approuvée",
            zhuxiaotijiao: "Votre demande d'annulation de marchand a été soumise",
            shenhefail: "Votre demande d'annulation de marchand n'a pas été approuvée",
            shenhesuc: "Votre demande d'annulation de marchand a été approuvée",
            shangjiazhuxiao: "annulation du marchand",
            shenagain: "examiner",
            shenheshibai: "Audit échoué",
            sheqinggain: "Postuler",
            reason: "raison",
            shenqingtuibao: "Demander un prêt",
            getquan: "Vous avez les autorisations suivantes",
            read: "J'ai lu et j'accepte",
            lijishenqing: "Postuler immédiatement",
            tips: "conseil",
            wufachexiao: "Vous êtes en cours d'annulation de marchand, après confirmation de la soumission de la demande, elle ne pourra pas être révoquée.",
            suredo: "Êtes-vous sûr de vouloir procéder ?",
            shuzizichan: "Certificat de transaction d'actifs numériques",
            gerenzichan: "Certificat d'actifs numériques personnels",
            second: {
                line: "Comment postuler pour devenir marchand ?",
                step1: "Étape 1 : préparez les documents de candidature selon les exigences",
                step1c1: "Préparez les documents suivants :",
                step1c2: "Numéro de téléphone mobile, ID WeChat, numéro QQ, certificat d'actifs numériques personnels (image), certificat de transaction d'actifs numériques (image)",
                step2: "Étape 2 : soumettre la candidature",
                step2c: "Pour compléter les matériaux d'audit de certification du marchand à remplir et télécharger, cliquez sur soumettre pour approbation.",
                step3: "Étape 3 : audit des données",
                stepc: "Nous examinerons vos candidatures commerciales dans les trois à cinq jours suivants, veuillez rester vigilant. Après approbation, vous pouvez publier des annonces dans la zone d'échange en monnaie fiduciaire.",
                agree: "Accepter de geler",
                agreec: "En tant que dépôt de marchand",
                shenqingchngweishangjia: "Postuler pour devenir marchand",
            },
            yuanyin: "raison",
            bizhong: "Devise de dépôt",
            shuliang: "Montant de la marge",
            chosen: "Sélectionner la devise",
            seat: 'Stand exclusif',
            service: 'Service personnalisé',
            lowfee: 'Frais réduits',
            phone: 'Téléphone',
            balance: 'Actifs personnels',
            cardphoto: 'Photos recto verso de la carte d\'identité',
            wx: 'Wechat',
            exchange: 'Engagez-vous dans le trading d\'actifs numériques hors bourse',
            handphoto: 'Photo avec carte d\'identité en main',
            qq: 'QQ',
            ploy: 'Existe-t-il une stratégie de contrôle des risques correspondante',
            agreement: '《Accord de marchand certifié》',
            applyfor: 'Postuler',
            sendcode: 'Envoyer',
            confirm: 'Confirmer',
            prepare: 'Préparer les documents',
            result: "Attendre le résultat",
            review: 'Soumettre pour examen',
            passed: 'Examen approuvé',
            approve: 'Veuillez accepter l\'accord de marchand certifié',
            emailtip1: 'Veuillez envoyer les documents suivants par e-mail à',
            emailtip2: 'Nous examinerons votre candidature dès que possible.',
        },
        extension: {
            title1: 'Liens de promotion',
            title2: 'Amis de promotion',
            title3: 'Ma commission',
            linkdesc: 'L\'URL suivante est votre adresse de promotion vers l\'extérieur. Vous pouvez la promouvoir via des amis, QQ, Wechat, Weibo, blogs, forums ou votre propre site web. Toutes les personnes qui ont accédé via cette adresse seront vos utilisateurs après inscription, et lorsque ces utilisateurs soumettent des stratégies sur ce site, vous pouvez gagner des commissions.',
            linktitle: 'Vos liens de promotion',
            copy: 'Copier',
            copy_msg1: 'Copie réussie !',
            copy_msg2: 'Échec ! Veuillez copier manuellement',
            username: 'Nom',
            currrecharge: 'Transaction',
            userlevel: 'Niveau utilisateur',
            createdtime: 'Date d\'inscription',
            currcommission: 'Commission actuelle',
            managerfee: 'frais de gestion',
            yuan: 'yuan (RMB)',
            symbol: 'DEVISE',
            amount: 'Montant',
            remark: 'Remarque',
            amounttime: 'Date de livraison',
        },
        promotion: {
            title: "Centre de promotion",
            subtitle1: "Mes cartes",
            subtitle2: "Historique des échanges",
            subtitle3: "Ma promotion",
            card_column0: "Code d'échange",
            card_column1: "Nom",
            card_column2: "Symbole de la devise",
            card_column3: "Montant",
            card_column4: "Date limite",
            card_column5: "Total",
            card_column6: "Échangé",
            card_column7: "Date de création",
            my_column0: "Utilisateur invité",
            my_column1: "Date d'inscription",
            my_column2: "Nom réel",
            gopromotion: "Promotion",
            inputcardno: "Veuillez entrer le code de la carte",
            exchange: "Échanger",
            exchangesuccess: "Félicitations ! Vous pouvez vérifier les actifs dans le centre financier !",
            exchangewithcode: "Échanger avec un code"
        },
        activity: {
            navTitle: "Innovation ",
            subNavTitle1: "Mes commandes",
            subNavTitle2: "Mon mining",
            subNavTitle3: "Mes verrouillages",
            column1: "Nom",
            column2: "Type",
            column3: "Montant",
            column4: "Unité (ENTRÉE)",
            column5: "Unité (SORTIE)",
            column6: "Statut",
            column7: "Chiffre d'affaires",
            column8: "Date de création",
            mColumn1: "Image",
            mColumn2: "Nom",
            mColumn3: "Unité de devise",
            mColumn4: "Période",
            mColumn5: "Jours de mining",
            mColumn6: "Jours minés",
            mColumn7: "Statut",
            mColumn8: "Capacité de base",
            mColumn9: "Capacité actuelle",
            mColumn10: "Total miné",
            mColumn11: "Date de fin",
            mColumn12: "Date de création",
            lColumn1: "Image",
            lColumn2: "Nom",
            lColumn3: "Unité de devise",
            lColumn4: "Période",
            lColumn5: "Jours verrouillés",
            lColumn6: "Jours libérés",
            lColumn7: "Statut",
            lColumn8: "Capacité de base",
            lColumn9: "Capacité actuelle",
            lColumn10: "Total libéré",
            lColumn11: "Date de fin",
            lColumn12: "Date de création",
        },
        mining: {
            title: "Ma liste de mining",
            empty: "Aucun enregistrement",
            day: "Jour",
            week: "Semaine",
            month: "Mois",
            year: "Année",
            invitetip1: "La capacité de la machine de mining peut être améliorée en invitant des amis. Chaque personne invitée à échanger la machine de mining augmentera la capacité de ",
            invitetip2: "Limite supérieure d'augmentation de la capacité ",
            miningUnit: "Unité de mining",
            miningPeriod: "Période de mining",
            miningDays: "Nombre de minings",
            miningedDays: "Minings effectués",
            miningDaysProfit: "Production de base",
            miningCurrentDaysProfit: "Production actuelle",
            status0: "À déployer",
            status1: "Déployé",
            status2: "Terminé"
        },
        locked: {
            title: "Ma liste de verrouillages",
            empty: "Aucun enregistrement",
            day: "Jour",
            week: "Semaine",
            month: "Mois",
            year: "Année",
            invitetip1: "La capacité du verrouillage peut être améliorée en invitant des amis. Chaque personne invitée à échanger le verrouillage augmentera la capacité de ",
            invitetip2: "Limite supérieure d'augmentation de la capacité ",
            miningUnit: "Unité de libération",
            miningPeriod: "Période de libération",
            miningDays: "Nombre de libérations",
            miningedDays: "Libérations effectuées",
            miningDaysProfit: "Production de base",
            miningCurrentDaysProfit: "Production actuelle",
            status0: "À libérer",
            status1: "En cours de libération",
            status2: "Terminé",
            totallocked: "Total verrouillé"
        },
        api: {
            apiAdmin: "Gestion API",
            createApi: "Créer une nouvelle clé API ",
            mark: "remarque",
            bindAddress: "La clé d'adresse IP non liée est valide 90 jours",
            hint: 'conseil',
            part1: "Nous vous fournissons une API puissante, vous pouvez utiliser des requêtes de marché, des transactions automatiques et d'autres services",
            apiDoc: "via la documentation API.",
            howUse: "Voir comment utiliser",
            part2: "Créer jusqu'à 5 ensembles de clés API par utilisateur",
            part3: "Veuillez ne pas divulguer votre clé API pour éviter la perte d'actifs. Pour des raisons de sécurité, il est recommandé de lier une IP à la clé API, avec un maximum de 5 IP pour chaque clé API.",
            myApiKey: "Ma clé API",
            ipAddress: "Adresse IP",
            createTime: "Date de création",
            accessKey: "Clé d'accès",
            bindIpAddress: "Lier l'adresse IP",
            ioDays: "Jours restants",
            operation: "opération",
            create: "créer",
            edit: "modifier",
            delete: "supprimer",
            sureDelete: "Êtes-vous sûr de vouloir supprimer ?",
            tips: "La clé n'est affichée que lors de l'ajout, veuillez la sauvegarder à temps.",
            copy: "copier",
            access: "clé",
            okText: "confirmer",
            cancel: "annuler"
        }
    },
    cms: {
        noticecenter: 'Centre d\'annonces',
        newshelp: 'Aide aux nouveaux utilisateurs',
        appdownload: 'Télécharger l\'App',
        onlineservice: 'service en ligne',
        faq: 'FAQ',
        notice: 'Annonces',
        servicecenter: 'Centre client',
        about: 'À propos',
        joinus: 'Rejoignez-nous',
        aboutus: 'À propos de nous',
        exchangerule: 'Règles de trading',
        useprotocol: 'Accord d\'utilisation',
        feenote: 'Description des frais',
        merchantprocotol: 'Accord du marchand',
        features: "Fonctionnalités",
        contactus: "Contactez-nous",
        noticelist: 'Toutes les annonces',
        nextnotice: 'SUIVANT',
        prevnotice: "PRÉCÉDENT",
        notexist: "La page que vous avez visitée n'existe pas ou a été supprimée",
        otherhelp: "Autres dans cette catégorie",
        scanforshare: "Scanner pour partager",
        download: "Télécharger",
        downloadslogan: "BIPPAX APP - Tradez partout."
    },
    description: {
        title1: 'Sécurité',
        title2: 'Service 24H',
        title3: 'Échange mondial',
        title4: 'Projets stricts',
        message1: 'Système complet de contrôle des risques financiers et système antivol, portefeuille chaud et froid, système multi-signatures pour assurer la sécurité des fonds',
        message2: 'Audit humain en ligne 24H pour protéger les clients contre les opportunités d\'investissement manquées.',
        message3: 'Couverture du réseau de services commerciaux mondiaux pour vous aider à investir dans les actifs cryptés mondiaux et à effectuer des transactions avec les utilisateurs du monde entier',
        message4: 'Nous sélectionnons strictement les projets blockchain de haute qualité pour filtrer 80% des projets à très haut risque pour vous.',
        scanqrcode: "Télécharger l'APP",
        aboutdesc1: "BIPPAX.PRO est une plateforme de trading d'actifs numériques de premier plan dans le monde, enregistrée aux îles Caïmans, avec une équipe opérationnelle principale à Hong Kong. Les membres principaux de BIPPAX.PRO proviennent des meilleures entreprises Internet et financières. La plupart d'entre eux sont de profonds croyants en Bitcoin et en la blockchain. Nous sommes convaincus que la blockchain changera le système financier monopolistique traditionnel et construira une structure sociale plus démocratique et autonome.",
        aboutdesc2: "La plateforme BIPPAX.PRO dispose d'une architecture de trading de niveau financier professionnel, un moteur de correspondance de trading en mémoire à haute concurrence développé en interne. La plateforme utilise un système de portefeuille de recharge entièrement froid + signatures multiples + système de protection DDOS haute sécurité et d'autres architectures de trading pour assurer la sécurité des actifs des clients.",
        aboutdesc3: "Afin de permettre aux clients de mieux saisir les opportunités d'investissement, BIPPAX.PRO adopte une gestion horizontale dans le département du service client et établit un mécanisme de réponse de service extrêmement rapide. Le gestionnaire du service client des actifs est en ligne 7*24H toute l'année, fournissant aux clients des services tels que la recharge et le retrait d'actifs, et assurant que les clients complètent la recharge en 25 minutes.",
        aboutdesc4: "BIPPAX.PRO sélectionne strictement les projets de haute qualité et fournit des services d'hébergement d'actifs sécurisés et stables. BIPPAX.PRO adhère au concept d'« honnêteté, justice, enthousiasme et ouverture », et s'efforce de créer un échange sûr, fiable, efficace et convivial pour les utilisateurs.",
        aboutdesc5: "Bien que les actifs numériques ne soient actuellement que dans un petit cercle, nous croyons que ce type d'actifs que chacun peut pleinement maîtriser sera populaire à l'avenir. Travaillons ensemble et attendons avec impatience !",
        support: "Support",
        report: "Suggestion",
        service: "Service client",
        apply: "Demande de listing",
        coop: "Coopération",
        community: "Communauté BIPPAX",
        wechat: "Wechat",
        addwechat: "Ajoutez 'coinex' comme ami Wechat puis rejoignez la communauté Wechat",
        weibo: "Weibo",
        twitter: "Twitter",
        biyong: "Biyong",
        telegram: "Telegram",
        medium: "Medium",
        reddit: "Reddit"
    },
    bzb_description: {
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        title5: "",
        title6: "",
        title7: "",
        title8: "",
        desc1: "",
        desc2: "",
        desc3: "",
        desc4: "",
        desc5: "",
        desc6: "",
        desc7: "",
        desc8: ""
    },
    footer: {
        wechatkefu: "service wechat",
        notice: 'Annonces',
        gsmc: 'Échangez les meilleures cryptomonnaies',
        bah: 'N° 13026899 -3, Shanghai ICP',
        gsjj: 'Profil',
        gywm: 'À propos de nous',
        jrwm: 'Rejoignez-nous',
        biyong: 'BiYong',
        lxwm: 'Contactez-nous',
        yqlj: 'Liens',
        bzzx: 'Aide',
        xsrm: "Cours pour débutants",
        czzn: 'Guide de recharge',
        jyzn: 'Guide de trading',
        ptsm: 'Explication',
        fysm: 'Frais',
        fwtk: 'Politique de service',
        fltk: 'Politique juridique',
        wechat: "Service client Wechat",
        xszn: "Guide du débutant",
        cjwt: "FAQ",
        mztk: "Avertissement",
        ystk: "Politique de confidentialité",
        tkxy: "Conditions",
        gybzb: "À propos de BZB",
        kfyx: "E-mail de service",
        swhz: "Coopération",
        sbsq: "Demande de marché",
        jyzn: "Guide d'échange",
        bzzl: "Infos sur les devises",
        tsjb: "Signaler",
        apidoc: "Doc API",
        zwkf: "bientôt disponible"
    },
    index: {
        circulation: 'Circulation du fonds de sécurité et de développement',
        hourEth: 'Revenus cumulés à distribuer aujourd\'hui',
        yesterdayEth: 'Revenus cumulés à distribuer hier',
        yesterday: 'Production minière du jour précédent :',
        bhbTotal: "Flux total BHB",
        bhbSecond: "Circulation du marché secondaire BHB",
        checkMineprinciple: "Voir le principe du mining",
        checkFlowVolum: 'Inspection de la circulation',
        checkLockPosition: 'Vérifier la situation de verrouillage',
        BHBregister: "Inscription au compte BIPPAX",
        tibi: "Le délai et la limite de paiement pour le retrait",
        line_plane: "Annonce sur le plan de mise en ligne, la circulation et le retour des frais de service de BHB",
        fenpeijizhi: 'Description du mécanisme de distribution des revenus de BIPPAX',
        jiangli_jihua: "Programme de récompense de mining par invitation",
        friend_fanhuan: "Invitez des amis, gagnez des frais supplémentaires et des retours"
    },
    plate: {
        title: "Plan de distribution des revenus de la plateforme (droits des détenteurs de BHB)",
        content1: "Comme décrit dans le livre blanc, BIPPAX prendra 80% des revenus de la plateforme (après déduction des taxes et frais) et les attribuera aux détenteurs de BHB, et 20% des revenus seront utilisés pour soutenir la R&D et l'exploitation de la plateforme.",
        content2: "La distribution des revenus se fait par cycle de jours, et le 6 juin 2018 est le premier jour de distribution. Chaque jour après cela, le total des revenus à distribuer du jour précédent sera attribué aux détenteurs de BHB en proportion.",
        content3: "(avis : 1. le BHB ici ne se réfère qu'au BHB qui a été libéré/en circulation. Voir aussi【",
        content3_1: 'Note sur le ratio de circulation/participation à la distribution des revenus de BHB',
        content3_2: "2. un instantané horaire (heure pleine) est calculé une fois et la distribution des revenus est exécutée une fois par jour.",
        hourFenpei: "Distribution des revenus aujourd'hui",
        hourTotal: "Revenu total de la plateforme aujourd'hui",
        xiangqing: "Détails de la distribution des revenus d'aujourd'hui",
        yesterdaytit: "Distribution des revenus d'hier",
        yesterdaytotal: "Revenu total de la plateforme d'hier",
        yesterdayxiangqing: "Détails de la distribution des revenus d'hier",
        yesterday: {
            total: "Revenus totaux",
            allocated: "Revenus non distribués",
        }
    },
    feereturn: {
        ruletitle: "Remarque",
        rulecontent: 'Notre livre blanc a une explication détaillée du remboursement des frais de transaction. Globalement, 51% de la base totale de BHB de la plateforme (appelée « portion de récompense communautaire » à partir de maintenant) sera remboursée aux utilisateurs au fil du temps via notre mécanisme de « Mining par frais de transaction ». Cependant, une fois que ces 51% du total des BHB auront été entièrement libérés via le remboursement, le mécanisme de « Mining par frais de transaction » se terminera automatiquement.',
        recordtitle: 'Liste',
        recordcontent: 'Chaque jour (UTC+8, idem ci-dessous), BHB remboursera 100% des frais de transaction des utilisateurs encourus la veille sous forme de BHB. Cela sera fait en utilisant le prix moyen de BHB de la veille. Nous compléterons ce remboursement des frais de transaction de la veille sous forme de BHB, à 11h chaque jour.',
        time: "Date",
        todaycharge: "Prix moyen (ETH)",
        totalChange: 'Total (ETH)',
        returnCharge: "Remboursement du mining par frais de transaction (BHB)",
        todayChargeReturn: "Programme d'incitation de remboursement FCoin (BHB)"
    },
    home: {
        login: {
            title: 'Commencez à trader des cryptomonnaies',
            desc: 'Support de plus de 500 cryptomonnaies et divers outils de trading',
            btnText: 'Trader maintenant'
        },
        unlogin: {
            title: 'Commencez votre voyage avec les actifs numériques',
            desc: 'Inscrivez-vous et profitez du coffret cadeau nouvel utilisateur',
            placinfo: 'Téléphone/E-mail',
            btnText: 'Inscription'
        },
        WelfareCenter: 'Centre de bien-être',
        Welcome_ceremony: 'Cadeau nouvel utilisateur',
        Airdrop: 'Airdrop',
        DailyGain: 'Récompenses quotidiennes',
        AirdropGift: 'Cadeaux Airdrop',
        financial_management: 'Gestion financière optimisée',
        Zhoude: 'Récompenses hebdomadaires',
        height_is: 'jusqu\'à',
        Happiness: 'Carnaval de la fortune',
        Monthly: 'Récompenses mensuelles',
        CarveUp: 'Cagnotte',
        download: {
            transactions_anytime: 'Tradez à tout moment, n\'importe où',
            scan_code: 'Scanner pour télécharger',
            download_more: 'Plus de téléchargements'
        },
        brand: {
            digital_platform: 'Plateforme de trading d\'actifs numériques de premier plan',
            rich_digital: 'Services riches de trading et de gestion d\'actifs numériques pour répondre à des besoins de trading diversifiés',
            High_quality_digital: 'Actifs numériques de haute qualité',
            Turnover: 'Chiffre d\'affaires',
            safety_risk: 'Système de sécurité et de gestion des risques de classe mondiale',
            multi_factor: 'Stockage hors ligne, chiffrement multi-facteurs, surveillance de la plateforme 24h/24 7j/7, protection complète de la sécurité des actifs des utilisateurs',
            Security_reserve: 'Fonds de réserve de sécurité',
            accident: '0 incident en 9 ans',
            safetyrisk: 'Sécurité et contrôle des risques de premier niveau',
            choice_trusted: 'Le choix de confiance de millions d\'utilisateurs',
            transaction_service: 'Des centres de services de transaction localisés établis dans plusieurs pays et régions du monde, créant un écosystème blockchain avec de multiples formes commerciales',
            ten_thousand: '10 000',
            User_preference: 'Préféré par les utilisateurs',
            Countries_covered: 'Pays couverts'
        },
        trading: {
            digital_currency: 'Commencez votre voyage avec les actifs numériques',
            register: 'Inscription',
            login: 'Connexion',
            currency_transaction: 'Commencez à trader des cryptomonnaies',
            to_trade: 'Trader maintenant'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/fr/index.js